// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Generated: 2026-09-23T19:54:41.212Z
// Property: Sunset Summit (ID: 6767906449166911)
// Collections: 31 amenities, 8 floorplans (live), 58 photos, 37 POIs, 1 reviews, 5 virtual tours, 6 office hours
// Live collections (fetched at runtime): floorplans, special_offers

export const property = {
  "multihub_agency_id": "5680529164730368",
  "multihub_company_id": "5767906449162446",
  "multihub_property_id": "6767906449166911",
  "property_external_id": "495838",
  "property_zillow_url": "https://www.zillow.com/homedetails/2151-Sunset-Blvd-Rocklin-CA-95765/188075649_zpid/",
  "property_apartments_url": "https://www.apartments.com/sunset-summit-rocklin-ca/596bgdq/",
  "property_google_business_url": "https://www.google.com/maps/place/Sunset+Summit+Apartments/data=!4m2!3m1!1s0x0:0x613645ef99d5e454?sa=X&ved=2ahUKEwjVmrTIm7ySAxWerIkEHbuGHZYQ_BJ6BAgPEAA&hl=en&gl=us",
  "property_linkedin_url": null,
  "property_hubspot_id": "54751435426",
  "property_crm_software": "Yardi RentCafe",
  "property_pm_software": "Yardi",
  "property_pm_info": "495838 p0505506",
  "property_status": null,
  "property_slug": "sunset-summit",
  "property_name": "Sunset Summit",
  "property_website_url": "www.rocklin-apartments.com",
  "property_domain": "https://www.rocklin-apartments.com/",
  "property_address": "2151 Sunset Blvd",
  "property_full_address": "2151 Sunset Blvd, Rocklin, CA, 95765",
  "property_address_1": "2151 Sunset Blvd",
  "property_address_2": null,
  "property_address_city": "Rocklin",
  "property_address_state": "CA",
  "property_address_zip_full": null,
  "property_address_zip": "95765",
  "property_address_country": "US",
  "property_address_county": "Placer County",
  "property_neighborhood_address": "Outer Roseville/Rocklin",
  "property_address_latitude": "38.8086",
  "property_address_longitude": "-121.275",
  "property_email": "sunsetsummit@ctlmanagement.com",
  "property_phone": "(279) 529-5312",
  "property_call_tracking_phone": null,
  "property_company_name": "CTL Management ",
  "property_company_url": "https://ctlmanagement.randallgroup.com/",
  "agency_contacts": null,
  "property_type": null,
  "property_short_description": "At Sunset Summit in Rocklin, CA, our thoughtfully designed one, two, and three-bedroom apartments offer modern amenities and scenic views. Enjoy a vibrant lifestyle with a sparkling pool, 24-hour fitness center, and a cozy coffee bar. Experience the perfect blend of comfort and convenience—your new home awaits!",
  "property_long_description": "**Welcome to Sunset Summit - Your Dream Home Awaits in Rocklin, CA!**\n\nDiscover the perfect blend of comfort and luxury at Sunset Summit, where our diverse floor plans accommodate every lifestyle. Choose from our spacious one-bedroom, two-bedroom, or three-bedroom apartments designed with your needs in mind. Each home features modern amenities, including stainless-steel appliances, dual sinks in the bathroom, and a private patio or balcony that offers stunning scenic views.\n\nAt Sunset Summit, we prioritize your comfort and convenience. Relax and unwind at our resort-style swimming pool, revel in the soothing indoor spa, or stay active at our 24-hour fitness center. Our welcoming clubhouse, equipped with complimentary Wi-Fi, is perfect for socializing or hosting events, while our resident activity program ensures there's always something fun to participate in. Need a space for work? Utilize our fully-equipped business center and enjoy the convenience of online rent payments and service requests.\n\nFamilies will love our playground, while everyone can take advantage of our flexible lease terms and smoke-free housing. Parking is a breeze with our garage options and 24-hour package lockers for added security.\n\nLocated in the heart of Rocklin, CA, Sunset Summit not only offers beautiful homes but also a thriving community. Experience the lifestyle you deserve in a community that truly feels like home. \n\n**Find your new home today – browse our availability or schedule a tour to visit our community!** We can't wait to welcome you to Sunset Summit!",
  "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166911/019f646b-5e57-74e8-affa-a4de11ad0e8c.webp",
  "property_featured_image_media": {
    "alt_text": "Outdoor swimming pool with lounge chairs and umbrellas",
    "public_id": "019f646b-5e57-74e8-affa-a4de11ad0e8c",
    "storage_key": "property/6767906449166911/019f646b-5e57-74e8-affa-a4de11ad0e8c.webp",
    "width": 1800,
    "height": 1202
  },
  "property_featured_video": null,
  "property_featured_video_media": null,
  "property_total_units": "344",
  "property_year_built": "1999",
  "property_year_renovated": null,
  "property_walk_score": null,
  "property_transit_score": null,
  "property_business_hours_list": null,
  "property_current_occupancy": "95.63953488372093",
  "property_admin_fee": null,
  "property_application_fee": null,
  "property_fees_deposit_info": "Deposit: $500-600",
  "property_ispetfriendly": true,
  "property_allows_cats": true,
  "property_allows_dogs": true,
  "property_upfront_pet_fee": "0",
  "property_pet_deposit": "0",
  "property_monthly_pet_rent": "30",
  "property_max_pets": "2",
  "property_max_pet_weight_limit": "25",
  "property_pet_restrictions": " ",
  "property_pet_policy_description": "Only indoor adult cats and indoor adult dogs are allowed; adult is defined as at least one year old. Monthly pet rent is per pet.  Small caged animals are allowed without pet rent. Small caged animals that are allowed are common domesticated household birds, hamsters, gerbils, rabbits, guinea pigs, chinchillas and aquarium/terrarium animals including fish, hermit crabs, turtles, frogs, and small lizards.  Animals such as birds of prey, iguanas, ferrets, snakes, rats, mice, insects, arachnids (including spiders and scorpions), livestock, or any other exotic animals are not allowed. No animals are allowed that are venomous, biting, stinging, constricting, or pose a threat of infestation. Small animals are limited to a maximum of two, with the exception of fish which should be kept to a reasonable amount, and must be kept confined in appropriate and reasonably sized cages or aquariums/terrariums.  Resident shall not have more than three aquariums and the total combined capacity between all aquariums shall not exceed 40 gallons.",
  "property_petpolicy_info": "Maximum Number of Pets: 2 (Only indoor adult cats and indoor adult dogs are allowed; adult is defined as at least one year old)\nMaximum Weight Limit: 25 pounds\nMonthly Pet Rent: $30 per pet",
  "property_online_leasing_url": "https://rocklin-apartments.securecafe.com/onlineleasing/sunset-summit-0/floorplans.aspx",
  "property_resident_portal_url": "https://rocklin-apartments.securecafe.com/residentservices/sunset-summit-0/userlogin.aspx",
  "property_apply_now_url": "https://rocklin-apartments.securecafe.com/onlineleasing/sunset-summit-0/guestlogin.aspx",
  "property_community_amenities_list": null,
  "property_apartment_features_list": null,
  "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166911/019db14c-97c4-70e8-8f27-9c591688368f.webp",
  "property_primary_logo_media": {
    "alt_text": "Sunset Summit Apartments logo",
    "public_id": "019db14c-97c4-70e8-8f27-9c591688368f",
    "storage_key": "property/6767906449166911/019db14c-97c4-70e8-8f27-9c591688368f.webp",
    "width": 737,
    "height": 160
  },
  "property_secondary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166911/019db14c-97e9-768e-aea4-06a8be6cae3a.webp",
  "property_secondary_logo_media": {
    "alt_text": "Sunset Summit Apartments logo",
    "public_id": "019db14c-97e9-768e-aea4-06a8be6cae3a",
    "storage_key": "property/6767906449166911/019db14c-97e9-768e-aea4-06a8be6cae3a.webp",
    "width": 737,
    "height": 160
  },
  "property_icon": null,
  "property_icon_media": null,
  "property_fav_icon": null,
  "property_fav_icon_media": null,
  "property_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166911/019de0b2-53e7-73da-bcce-d5d11ea0bcc6.webp",
  "property_mono_white_logo_media": {
    "alt_text": "Blank white rectangular space surrounded by dark gray borders.",
    "public_id": "019de0b2-53e7-73da-bcce-d5d11ea0bcc6",
    "storage_key": "property/6767906449166911/019de0b2-53e7-73da-bcce-d5d11ea0bcc6.webp",
    "width": 737,
    "height": 160
  },
  "property_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166911/019de0b2-46f6-713f-9855-93df3d6427bc.webp",
  "property_mono_black_logo_media": {
    "alt_text": "Graphic of a black horizontal bar on a white background.",
    "public_id": "019de0b2-46f6-713f-9855-93df3d6427bc",
    "storage_key": "property/6767906449166911/019de0b2-46f6-713f-9855-93df3d6427bc.webp",
    "width": 737,
    "height": 160
  },
  "property_company_icon": null,
  "property_company_icon_media": null,
  "property_company_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162446/019d9c74-7219-719e-b7ea-ff6185375ae5.webp",
  "property_company_logo_media": {
    "alt_text": "CTL Management logo",
    "public_id": "019d9c74-7219-719e-b7ea-ff6185375ae5",
    "storage_key": "company/5767906449162446/019d9c74-7219-719e-b7ea-ff6185375ae5.webp",
    "width": 201,
    "height": 60
  },
  "property_company_mono_black_logo": null,
  "property_company_mono_black_logo_media": null,
  "property_company_mono_white_logo": null,
  "property_company_mono_white_logo_media": null,
  "property_primary_color": "#14473D",
  "property_secondary_color": "#9EBAC2",
  "property_font_color": "#14473D",
  "property_color_4": "#F27859",
  "property_color_3": "#4F756E",
  "property_color_5": "#FAAD45",
  "property_color_6": "#FCF5F0",
  "property_color_7": "#CFDBE0",
  "property_color_8": "#FCE3BD",
  "property_bedrooms_range": "1 - 3",
  "property_bedrooms_min": "1",
  "property_bedrooms_max": "3",
  "property_bathrooms_range": "1 - 2",
  "property_bathrooms_min": "1",
  "property_bathrooms_max": "2",
  "property_sqft_range": "664 - 1174",
  "property_sqft_min": "664",
  "property_sqft_max": "1174",
  "property_price_range": "1830 - 4290",
  "property_price_min": "1830",
  "property_price_max": "4290",
  "property_available_units": 15,
  "property_facebook_url": "https://www.facebook.com/sunsetsummitapartments/",
  "property_instagram_url": null,
  "property_twitter_url": null,
  "property_google_place_url": "https://www.google.com/maps/place/?q=place_id:ChIJ_8GoWrIjm4ARVOTVme9FNmE",
  "property_youtube_url": "https://www.youtube.com/shorts/MZEDKpB5_Zc",
  "property_yelp_url": "https://www.yelp.com/biz/sunset-rocklin-townhomes-rocklin",
  "property_tiktok_url": null,
  "property_specialoffer_title": null,
  "property_specialoffer_description": null,
  "property_specialoffer_disclaimer": null,
  "property_home_hero_title": "Welcome to Sunset Summit",
  "property_home_romance_title": "Embrace a Life of Comfort and Connection at Our Community",
  "property_home_amenities_blurb": "Welcome to Sunset Summit in Rocklin, CA, where comfort meets convenience. Our thoughtfully designed one, two, and three-bedroom apartments offer private patios, modern stainless-steel appliances, and scenic views. Enjoy lifestyle-inspired amenities like a sparkling swimming pool, 24-hour fitness center, and a cozy coffee bar—all tailored for you!",
  "property_home_floorplans_blurb": "At Sunset Summit in Rocklin, CA, your ideal lifestyle awaits within our diverse floor plans. Each apartment is designed to reflect comfort and modern living, offering a serene retreat with stunning views. Browse our available homes today and uncover the perfect canvas for your next chapter!",
  "property_home_gallery_blurb": "At Sunset Summit in Rocklin, CA, your ideal home awaits. Choose from thoughtfully designed one, two, or three-bedroom floor plans showcasing modern amenities like stainless-steel appliances, private patios, and a vibrant community atmosphere. With a stunning clubhouse, sparkling pool, and lush landscapes, picture yourself living here!",
  "property_home_neighborhood_blurb": "Welcome to Sunset Summit in Rocklin, CA—a vibrant haven where comfort meets community. Nestled near the serene Maidu Regional Park and Sierra College, our diverse floor plans accommodate your lifestyle. Embrace convenience with shopping at the Westfield Galleria and activities at Roseville Golfland Sunsplash. Uncover the perfect balance of relaxation and excitement!",
  "property_home_reviews_blurb": "At Sunset Summit in Rocklin, CA, residents rave about the “friendly atmosphere and stunning sunsets.” Immerse yourself in a vibrant community where comfort meets breathtaking views. Ready to feel at home? See what our residents have to say about living at our community and discover your perfect sanctuary today!",
  "property_neighborhood_blurb": "Nestled in the heart of Rocklin, Sunset Summit offers more than just stylish living. Enjoy nearby attractions like Sierra College’s Natural History Museum and the tranquil Maidu Regional Park. From engaging cultural sites to invigorating athletic facilities, your vibrant lifestyle awaits just beyond our doorstep. Uncover the local treasures around you!",
  "property_accessibility_blurb": null,
  "property_amenities_blurb": "At Sunset Summit in Rocklin, CA, indulge in a lifestyle where comfort meets convenience. Enjoy spacious one, two, and three-bedroom apartments equipped with modern amenities like stainless-steel appliances, private patios, and a 24-hour fitness center. Join our vibrant community and elevate your living experience today!",
  "property_applynow_blurb": "At Sunset Summit in Rocklin, CA, choose from spacious one, two, or three-bedroom floor plans designed for your lifestyle. Enjoy top-tier amenities like a shimmering swimming pool, state-of-the-art fitness center, and relaxing indoor spa—perfect for unwinding. Embrace comfort and convenience; lease your new home online today!",
  "property_contactus_blurb": "At Sunset Summit in Rocklin, CA, our thoughtfully designed one, two, and three-bedroom apartments invite you to elevate your lifestyle. Each floor plan harmoniously blends comfort and style, offering the perfect backdrop for your unique story. Have questions? Contact our leasing team today to find your ideal home!",
  "property_faqs_blurb": "At Sunset Summit in Rocklin, CA, we offer thoughtfully designed one, two, and three-bedroom floor plans to suit every lifestyle. Curious about our community? Access our FAQs page for valuable insights and answers to your most pressing questions. Your perfect home awaits at Sunset Summit!",
  "property_floorplans_blurb": "At Sunset Summit in Rocklin, CA, we offer a variety of thoughtfully designed floor plans to suit your lifestyle. Whether you prefer the cozy charm of a one-bedroom, the spaciousness of a two-bedroom, or the expansive layout of a three-bedroom, your ideal apartment home awaits. Browse our available options today!",
  "property_gallery_blurb": "Capture the essence of luxury living at Sunset Summit in Rocklin, CA. Choose from spacious one, two, or three-bedroom floor plans featuring stunning finishes and scenic views. Enjoy top-tier amenities like a 24-hour fitness center, swimming pool, and a cozy coffee bar. Picture yourself living here—your dream lifestyle awaits!",
  "property_interactivemap_blurb": "At Sunset Summit in Rocklin, CA, your ideal living space awaits. Choose from spacious one, two, or three-bedroom floor plans, each thoughtfully designed with upscale amenities like stainless-steel appliances, private balconies, and a refreshing pool. Use our interactive community map to find your perfect home today!",
  "property_pets_blurb": "Nestled in the heart of Rocklin, CA, Sunset Summit is a serene haven for you and your furry companions. With spacious living and a welcoming atmosphere, we invite indoor adult cats and dogs to join our community, ensuring both you and your pets feel right at home. Embrace a lifestyle where comfort meets companionship!",
  "property_referafriend_blurb": "At Sunset Summit in Rocklin, CA, your perfect living space awaits! Choose from our thoughtfully designed one, two, and three-bedroom floor plans to suit your lifestyle. Great friends make great neighbors—refer a friend to our vibrant community today and enjoy the beauty of life at Sunset Summit together!",
  "property_residentaccess_blurb": "Welcome to Sunset Summit in Rocklin, CA! Seamlessly manage your living experience by logging into our resident portal. Enjoy convenient access to pay rent, schedule maintenance, and more, all while choosing from our thoughtfully designed one, two, and three-bedroom floor plans tailored to fit your lifestyle.",
  "property_reviews_blurb": "At Sunset Summit in Rocklin, CA, our residents rave about their experience, stating it’s a \"peaceful oasis with stunning views.\" Dive into our reviews to learn how our vibrant community and welcoming atmosphere can enhance your lifestyle. See what our residents have to say about living at our community!",
  "property_created_at": "1762785190021",
  "property_scheduletour_blurb": "At Sunset Summit in Rocklin, CA, our diverse floor plans—ranging from cozy one-bedroom retreats to spacious three-bedroom layouts—cater to your lifestyle. Schedule a tour today and experience the vibrant community firsthand. Curious about our residents' experiences? Check out their stories to see why they love calling Sunset Summit home!",
  "property_thankyou_blurb": "Thank you for reaching out to Sunset Summit in Rocklin, CA! We’re thrilled you’re interested in our diverse floor plans—ranging from cozy one-bedroom to spacious three-bedroom apartments. Stay tuned; our team will connect with you soon to help you find your perfect home amidst stunning views and vibrant community life.",
  "property_virtualtours_blurb": "Welcome to Sunset Summit in Rocklin, CA, where comfort meets style. Offering thoughtfully designed one, two, and three-bedroom layouts, each apartment invites you to experience modern living. Immerse yourself in our vibrant community—take a virtual tour today and envision your new home nestled among stunning sunset views!",
  "property_copyright": "2025 All Rights Reserved. Sunset Summit",
  "property_seo_title_home": "Sunset Summit |  Apartments in Rocklin, CA",
  "property_seo_description_home": "Discover Sunset Summit in Rocklin, CA! Enjoy spacious floor plans, resort-style amenities, and scenic views in our vibrant community.",
  "property_seo_title_floorplans": "Floor Plans | Rocklin, CA Apartments for Rent",
  "property_seo_description_floorplans": "Find your ideal space at Sunset Summit in Rocklin, CA. Choose from one, two, or three-bedroom apartments and uncover your dream floor plan today!",
  "property_seo_title_amenities": "Amenities | Rocklin, CA Apartments for Rent",
  "property_seo_description_amenities": "Experience the best of Rocklin at Sunset Summit! Enjoy spacious apartments, a stunning pool, and a vibrant clubhouse. Your perfect home awaits!",
  "property_seo_title_gallery": "Gallery | Apartments in Rocklin, CA",
  "property_seo_description_gallery": "Capture your dream home at Sunset Summit in Rocklin, CA! Picture serene views, stylish amenities, and vibrant community life.Luxury awaits!",
  "property_seo_title_virtualtours": "Virtual Tours | Sunset Summit Apartments",
  "property_seo_description_virtualtours": "Experience the charm of Sunset Summit in Rocklin, CA. Dive into our virtual tour and envision your future in our one, two, or three-bedroom apartments!",
  "property_seo_title_interactivemap": "Interactive Map | Sunset Summit Apartments",
  "property_seo_description_interactivemap": "Find your new home at Sunset Summit in Rocklin, CA! Use our interactive map to explore spacious layouts, luxury amenities, and vibrant community life.",
  "property_seo_title_neighborhood": "Neighborhood | Apartments in Rocklin, CA",
  "property_seo_description_neighborhood": "Uncover the charm of Sunset Summit in Rocklin, CA. Dive into local favorites, vibrant hotspots, and everything our neighborhood has to offer. Join us!",
  "property_seo_title_contact": "Contact Us | Sunset Summit",
  "property_seo_description_contact": "Reach out to Sunset Summit in Rocklin, CA! Whether you're eyeing a cozy one-bedroom or a spacious three-bedroom, our team is here to help. Contact us today!",
  "property_seo_title_faqs": "FAQs | Apartments in Rocklin, CA",
  "property_seo_description_faqs": "Get the scoop on Sunset Summit in Rocklin, CA! Have questions? Our FAQ page covers everything from amenities to leasing—it's your guide to carefree living!",
  "property_seo_title_reviews": "Resident Reviews | Apartments in Rocklin, CA",
  "property_seo_description_reviews": "Discover modern 1-3 bedroom apartments at Sunset Summit in Rocklin, CA, featuring great amenities and a vibrant community. Join us today!",
  "property_seo_title_applynow": "Apply Now | Apartments in Rocklin, CA",
  "property_seo_description_applynow": "Experience the tranquility of Sunset Summit in Rocklin, CA. Choose from spacious 1, 2, or 3-bedroom apartments with premier amenities. Apply online now!",
  "property_seo_title_residentaccess": "Resident Access | Sunset Summit",
  "property_seo_description_residentaccess": "Enter Sunset Summit's resident portal for easy rent payments, maintenance requests, and community updates. Your convenient living experience in Rocklin awaits!",
  "property_seo_title_referafriend": "Refer A Friend | Sunset Summit",
  "property_seo_description_referafriend": "Refer a friend to Sunset Summit in Rocklin, CA! Great friends make great neighbors. Share the joy of living in a vibrant community—start referring today!",
  "property_seo_title_scheduletour": "Schedule a Tour | Sunset Summit",
  "property_seo_description_scheduletour": "Experience the charm of Sunset Summit in Rocklin, CA! Schedule a tour today and envision your new lifestyle in our vibrant apartment community.",
  "property_seo_title_privacy": "Privacy Policy | Sunset Summit",
  "property_seo_description_privacy": "At Sunset Summit in Rocklin, CA, your privacy matters. Dive into our policy to see how we protect your personal space. Trust starts here! View now.",
  "property_seo_title_accessibility": "Website Accessibility | Sunset Summit",
  "property_seo_description_accessibility": "At Sunset Summit in Rocklin, CA, we prioritize digital inclusion. Experience accessible living with us—where comfort meets convenience for all.",
  "property_seo_title_sitemap": "Sitemap | Sunset Summit",
  "property_seo_description_sitemap": "Navigate Sunset Summit in Rocklin, CA! Find your way around our community, amenities, and more with our easy-to-use sitemap. Your next adventure awaits!",
  "property_seo_title_thankyou": "Thank You | Sunset Summit",
  "property_seo_description_thankyou": "Thank you for your interest in Sunset Summit, Rocklin’s serene retreat. Our team will be in touch soon to help you find your perfect home!",
  "property_seo_title_pets": "Pet Policy | Apartments in Rocklin, CA",
  "property_seo_description_pets": "Discover our comprehensive pet policy designed to ensure a comfortable and welcoming environment for you and your furry companions.",
  "property_updated_at": "1784311696456",
  "amenities": [
    {
      "id": "ec_c035b549b45f7aa0d74f7b14",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166911",
      "source": "yardi",
      "external_id": "80429547",
      "title": "Clubhouse with Complimentary Wi-Fi",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166911/019d1c14-84d3-75de-a111-b6d520b71683.webp",
      "amenity_image_media": {
        "alt_text": "Modern kitchen island with granite countertop and bar stools, stainless steel appliances, and grey cabinets.",
        "public_id": "019d1c14-84d3-75de-a111-b6d520b71683",
        "storage_key": "property/6767906449166911/019d1c14-84d3-75de-a111-b6d520b71683.webp",
        "width": 1800,
        "height": 1202
      },
      "amenity_image_alt_text": "Sunset Summit Clubhouse Interior Kitchen",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_6da8ee6fec52fa106f876ee4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166911",
      "source": "yardi",
      "external_id": "80429546",
      "title": "Business Center",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166911/019d1c14-8553-704c-9218-0a81549ebb02.webp",
      "amenity_image_media": {
        "alt_text": "Business center with desks, computers, and chairs.",
        "public_id": "019d1c14-8553-704c-9218-0a81549ebb02",
        "storage_key": "property/6767906449166911/019d1c14-8553-704c-9218-0a81549ebb02.webp",
        "width": 1800,
        "height": 1203
      },
      "amenity_image_alt_text": "Clubhouse Business Center at Sunset Summit, Rocklin, 95765",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_6b0b1cc67439b858b48a49c8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166911",
      "source": "yardi",
      "external_id": "80429544",
      "title": "24-Hour Fitness Center",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166911/019d1ee1-25d6-7619-b9d3-4cf17a03711a.webp",
      "amenity_image_media": {
        "alt_text": "Fitness center with treadmills, ellipticals, weight bench, and dumbbells.",
        "public_id": "019d1ee1-25d6-7619-b9d3-4cf17a03711a",
        "storage_key": "property/6767906449166911/019d1ee1-25d6-7619-b9d3-4cf17a03711a.webp",
        "width": 1800,
        "height": 1203
      },
      "amenity_image_alt_text": "Fitness Center Equipment at Sunset Summit, California, 95765",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_998680d4cbf7a2197282956a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166911",
      "source": "yardi",
      "external_id": "80429548",
      "title": "Indoor Spa",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166911/019d1ee1-2509-71cc-82c1-fdf1c1fac7c7.webp",
      "amenity_image_media": {
        "alt_text": "Indoor hot tub with wood-paneled ceiling and tiled walls.",
        "public_id": "019d1ee1-2509-71cc-82c1-fdf1c1fac7c7",
        "storage_key": "property/6767906449166911/019d1ee1-2509-71cc-82c1-fdf1c1fac7c7.webp",
        "width": 1200,
        "height": 798
      },
      "amenity_image_alt_text": "Indoor Spa at Sunset Summit, CA 95765",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_47db045e20b8e78a27578a91",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166911",
      "source": "yardi",
      "external_id": "80429551",
      "title": "Wading Pool",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_82de8b77bfb9daf565199107",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166911",
      "source": "yardi",
      "external_id": "86393088",
      "title": "Coffee Bar",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_5a3133ea39b0c82ee13d41a7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166911",
      "source": "yardi",
      "external_id": "80683702",
      "title": "Swimming Pool",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166911/019f646b-64c4-745b-948e-847ec63ee474.webp",
      "amenity_image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and tables under umbrellas.",
        "public_id": "019f646b-64c4-745b-948e-847ec63ee474",
        "storage_key": "property/6767906449166911/019f646b-64c4-745b-948e-847ec63ee474.webp",
        "width": 1800,
        "height": 1202
      },
      "amenity_image_alt_text": "A pool with a table and chairs with umbrellas at Sunset Summit, Rocklin, CA, 95765,A pool surrounded by trees and chairs under umbrellas at Sunset Summit, Rocklin, CA, 95765,A swimming pool is surrounded by chairs and umbrellas outside at Sunset Summit, Rocklin, CA, 95765",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_0094fdf111e952a69835846d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166911",
      "source": "yardi",
      "external_id": "87439856",
      "title": "24-Hour Package Lockers",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166911/019d1c14-84eb-72af-9a1a-f0f9c690ff91.webp",
      "amenity_image_media": {
        "alt_text": "Package lockers with a digital interface",
        "public_id": "019d1c14-84eb-72af-9a1a-f0f9c690ff91",
        "storage_key": "property/6767906449166911/019d1c14-84eb-72af-9a1a-f0f9c690ff91.webp",
        "width": 1800,
        "height": 1202
      },
      "amenity_image_alt_text": "Amazon Hub Package Center at Sunset Summit, Rocklin, CA",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_02636bd58c7a1e57a3f23fa2",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166911",
      "source": "yardi",
      "external_id": "80683703",
      "title": "Playground",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166911/019f646b-6a81-73ad-ae0a-2c35a934255d.webp",
      "amenity_image_media": {
        "alt_text": "Playground with slide, swings, and climbing structure under a large oak tree.",
        "public_id": "019f646b-6a81-73ad-ae0a-2c35a934255d",
        "storage_key": "property/6767906449166911/019f646b-6a81-73ad-ae0a-2c35a934255d.webp",
        "width": 1800,
        "height": 1202
      },
      "amenity_image_alt_text": "A playground with a shade structure at Sunset Summit, Rocklin, CA, 95765,A playground with a slide at Sunset Summit, Rocklin, CA, 95765",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_c07f16f2ffa7d10410cb2218",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166911",
      "source": "yardi",
      "external_id": "128189574",
      "title": "Dog Park",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166911/019f646b-7372-76ee-bb5a-297ab23b63b7.webp",
      "amenity_image_media": {
        "alt_text": "Dog park with agility tunnel and bench within a multifamily property.",
        "public_id": "019f646b-7372-76ee-bb5a-297ab23b63b7",
        "storage_key": "property/6767906449166911/019f646b-7372-76ee-bb5a-297ab23b63b7.webp",
        "width": 1800,
        "height": 1202
      },
      "amenity_image_alt_text": "A dog park with a green tunnel and a grey house in the background at Sunset Summit, Rocklin, CA, 95765",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_768291db5a6d93cb4d022670",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166911",
      "source": "yardi",
      "external_id": "86393091",
      "title": "Garages",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166911/019f646b-98ed-7740-a7fb-beed204cbfd4.webp",
      "amenity_image_media": {
        "alt_text": "Garages with multiple parking spots in a residential area.",
        "public_id": "019f646b-98ed-7740-a7fb-beed204cbfd4",
        "storage_key": "property/6767906449166911/019f646b-98ed-7740-a7fb-beed204cbfd4.webp",
        "width": 1800,
        "height": 1202
      },
      "amenity_image_alt_text": "A parking lot with garages and trees at Sunset Summit, Rocklin, CA, 95765",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_493a6240c6d59b6145f685e7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166911",
      "source": "yardi",
      "external_id": "86393087",
      "title": "Clubhouse Rentals",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_e20ef8171c839a96e6c7b42e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166911",
      "source": "yardi",
      "external_id": "80429549",
      "title": "Resident Activity Program",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_35993bd582d22904bcce1913",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166911",
      "source": "yardi",
      "external_id": "86393098",
      "title": "Flexible Lease Terms",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_3015ebe4883bd56a947e2d54",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166911",
      "source": "yardi",
      "external_id": "82390286",
      "title": "Online Rent Payments",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_60b4fe9ff9c2f34a0c516713",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166911",
      "source": "yardi",
      "external_id": "82390288",
      "title": "Online Service Requests",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_cd32e41a155b68dbb7c91526",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166911",
      "source": "yardi",
      "external_id": "86393099",
      "title": "Smoke Free Housing",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_aa2f3a003cb3acb6ec7f95bb",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166911",
      "source": "yardi",
      "external_id": "80429555",
      "title": "In-Unit Washer & Dryer",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166911/019f646a-e39e-7639-b660-c57d8caac7a5.webp",
      "amenity_image_media": {
        "alt_text": "Laundry room with washer, dryer, and electrical panel.",
        "public_id": "019f646a-e39e-7639-b660-c57d8caac7a5",
        "storage_key": "property/6767906449166911/019f646a-e39e-7639-b660-c57d8caac7a5.webp",
        "width": 1800,
        "height": 1202
      },
      "amenity_image_alt_text": "A laundry room with a washer and dryer at Sunset Summit, Rocklin, CA, 95765",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_28ab8c3267e15cdefef3643f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166911",
      "source": "yardi",
      "external_id": "80429554",
      "title": "Central Heating And Air",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_06a28beefadc8e9aa287925a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166911",
      "source": "yardi",
      "external_id": "80429560",
      "title": "Patio or Deck",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166911/019f646b-8843-7749-92e0-2b177bae5b62.webp",
      "amenity_image_media": {
        "alt_text": "Exterior view of apartment buildings with balconies and landscaping.",
        "public_id": "019f646b-8843-7749-92e0-2b177bae5b62",
        "storage_key": "property/6767906449166911/019f646b-8843-7749-92e0-2b177bae5b62.webp",
        "width": 1800,
        "height": 1202
      },
      "amenity_image_alt_text": "A row of apartments with a garden in front at Sunset Summit, Rocklin, CA, 95765",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_9459b8e59b3889acf1a5375b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166911",
      "source": "yardi",
      "external_id": "80429562",
      "title": "Vaulted Ceilings - In Select Homes*",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_a5f8f579bf55f54642ddc70d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166911",
      "source": "yardi",
      "external_id": "80429557",
      "title": "Linen Closets - In Select Homes*",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166911/019f646b-1170-73cd-8443-8473adfc73e0.webp",
      "amenity_image_media": {
        "alt_text": "Living room and kitchen area with vaulted ceilings and a ceiling fan.",
        "public_id": "019f646b-1170-73cd-8443-8473adfc73e0",
        "storage_key": "property/6767906449166911/019f646b-1170-73cd-8443-8473adfc73e0.webp",
        "width": 1800,
        "height": 1202
      },
      "amenity_image_alt_text": "A spacious room with a carpeted floor at Sunset Summit, Rocklin, CA, 95765",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_7829548c2f3f3b041c65dd4e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166911",
      "source": "yardi",
      "external_id": "80429559",
      "title": "Open Kitchens",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166911/019f646a-e28a-701c-ad86-00fe4347e068.webp",
      "amenity_image_media": {
        "alt_text": "Modern kitchen with white cabinets, granite countertops, stainless steel appliances, and wood-look flooring.",
        "public_id": "019f646a-e28a-701c-ad86-00fe4347e068",
        "storage_key": "property/6767906449166911/019f646a-e28a-701c-ad86-00fe4347e068.webp",
        "width": 1800,
        "height": 1202
      },
      "amenity_image_alt_text": "A kitchen with a black refrigerator and stove at Sunset Summit, Rocklin, CA, 95765",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_4b9582f378403e78e055fb32",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166911",
      "source": "yardi",
      "external_id": "80429556",
      "title": "Large Dining Room",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_f46466786af79ed8fe035f6a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166911",
      "source": "yardi",
      "external_id": "80429553",
      "title": "Breakfast Bar",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166911/019f646b-0c9a-7151-b522-fe1bf57986b6.webp",
      "amenity_image_media": {
        "alt_text": "Modern kitchen with white cabinets, granite countertops, stainless steel appliances, and a dishwasher.",
        "public_id": "019f646b-0c9a-7151-b522-fe1bf57986b6",
        "storage_key": "property/6767906449166911/019f646b-0c9a-7151-b522-fe1bf57986b6.webp",
        "width": 1800,
        "height": 1202
      },
      "amenity_image_alt_text": "A kitchen with a stove, sink, and cabinets at Sunset Summit, Rocklin, CA, 95765",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_5ffd35bfda1033e21e314997",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166911",
      "source": "yardi",
      "external_id": "87311356",
      "title": "Ceiling Fan",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166911/019f646b-1170-73cd-8443-8473adfc73e0.webp",
      "amenity_image_media": {
        "alt_text": "Living room and kitchen area with vaulted ceilings and a ceiling fan.",
        "public_id": "019f646b-1170-73cd-8443-8473adfc73e0",
        "storage_key": "property/6767906449166911/019f646b-1170-73cd-8443-8473adfc73e0.webp",
        "width": 1800,
        "height": 1202
      },
      "amenity_image_alt_text": "A spacious room with a carpeted floor at Sunset Summit, Rocklin, CA, 95765",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_435cc396ad37f9b63bea0744",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166911",
      "source": "yardi",
      "external_id": "80429558",
      "title": "Mirrored Closets",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166911/019f646b-1e19-73f9-85ae-360be6d1f5b8.webp",
      "amenity_image_media": {
        "alt_text": "Bedroom with mirrored closet doors and soft carpeting.",
        "public_id": "019f646b-1e19-73f9-85ae-360be6d1f5b8",
        "storage_key": "property/6767906449166911/019f646b-1e19-73f9-85ae-360be6d1f5b8.webp",
        "width": 1800,
        "height": 1202
      },
      "amenity_image_alt_text": "A room with a carpeted floor and mirrored closet doors at Sunset Summit, Rocklin, CA, 95765",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_472c3903fddd5f312d875a23",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166911",
      "source": "yardi",
      "external_id": "80429561",
      "title": "Private Entry",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_b4396cbcab8d3fb34b55abff",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166911",
      "source": "yardi",
      "external_id": "87311358",
      "title": "Dual Sinks In Bathroom - In Select Homes*",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_7d1cbe04cab5e6c8edee1d2a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166911",
      "source": "yardi",
      "external_id": "87311360",
      "title": "Scenic Views - In Select Homes*",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_4b4837ae34f12958be5e3822",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166911",
      "source": "yardi",
      "external_id": "87311363",
      "title": "Stainless Steel Appliances - In Select Homes*",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166911/019f646b-0a6a-76cc-a7e6-0397c29b28a0.webp",
      "amenity_image_media": {
        "alt_text": "Kitchen with white cabinets, granite countertops, and stainless steel appliances including a refrigerator, oven, and dishwasher.",
        "public_id": "019f646b-0a6a-76cc-a7e6-0397c29b28a0",
        "storage_key": "property/6767906449166911/019f646b-0a6a-76cc-a7e6-0397c29b28a0.webp",
        "width": 1800,
        "height": 1202
      },
      "amenity_image_alt_text": "A kitchen with white cabinets and a black refrigerator at Sunset Summit, Rocklin, CA, 95765",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    }
  ],
  "photo_gallery": [
    {
      "id": "ec_2e08f4da2357453ddf0e8678",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166911",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166911/019d23c3-f93d-72c8-b941-bde24989bd23.webp",
      "image_media": {
        "alt_text": "Living room with blue sofa, accent chairs, coffee table, and sliding glass door to patio.",
        "public_id": "019d23c3-f93d-72c8-b941-bde24989bd23",
        "storage_key": "property/6767906449166911/019d23c3-f93d-72c8-b941-bde24989bd23.webp",
        "width": 1800,
        "height": 1202
      },
      "title": "Apartment",
      "description": "Cozy living room featuring a comfortable blue sofa, accent chairs, and a coffee table, perfect for relaxing or entertaining guests. Enjoy the natural light from the sliding glass door leading to the patio.",
      "link": "false",
      "alt_text": "Living room with blue sofa, accent chairs, coffee table, and sliding glass door to patio.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/SunsetSummit_Rocklin_CA_ModelLivingRoomPatioSlider.jpg"
    },
    {
      "id": "ec_77ee85c85d2674265e6efd64",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166911",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166911/019d1f10-966e-749f-8af0-6d8338828410.webp",
      "image_media": {
        "alt_text": "Living room and dining area of an apartment.",
        "public_id": "019d1f10-966e-749f-8af0-6d8338828410",
        "storage_key": "property/6767906449166911/019d1f10-966e-749f-8af0-6d8338828410.webp",
        "width": 1800,
        "height": 1202
      },
      "title": "Apartment",
      "description": "Spacious living room with a navy sofa, accent pillows, and a coffee table, flowing into a dining area with a high-top table and bar stools at the kitchen counter.",
      "link": "false",
      "alt_text": "Living room and dining area of an apartment.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/SunsetSummit_Rocklin_CA_ModelKitchenBarLivingRoom.jpg"
    },
    {
      "id": "ec_72b177d8c9ef0d6b9cecbd02",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166911",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166911/019d1f10-998f-77a3-a334-2860a476177e.webp",
      "image_media": {
        "alt_text": "Living room and kitchen area with a breakfast bar",
        "public_id": "019d1f10-998f-77a3-a334-2860a476177e",
        "storage_key": "property/6767906449166911/019d1f10-998f-77a3-a334-2860a476177e.webp",
        "width": 1800,
        "height": 1202
      },
      "title": "Apartment",
      "description": "Spacious living area opening to a kitchen with a breakfast bar, perfect for entertaining.",
      "link": "false",
      "alt_text": "Living room and kitchen area with a breakfast bar",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/SunsetSummit_Rocklin_CA_ModelEntryKitchenBar.jpg"
    },
    {
      "id": "ec_a20e70d35e8b05752314b2e4",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166911",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166911/019d1f10-9604-7128-807a-8e4b33b4101d.webp",
      "image_media": {
        "alt_text": "Kitchen with light wood cabinets, white appliances, and black countertops.",
        "public_id": "019d1f10-9604-7128-807a-8e4b33b4101d",
        "storage_key": "property/6767906449166911/019d1f10-9604-7128-807a-8e4b33b4101d.webp",
        "width": 1800,
        "height": 1202
      },
      "title": "Apartment",
      "description": "Bright and functional kitchen featuring ample cabinet space, a full-sized refrigerator, stove, and dishwasher, perfect for everyday cooking.",
      "link": "false",
      "alt_text": "Kitchen with light wood cabinets, white appliances, and black countertops.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/SunsetSummit_Rocklin_CA_ModelKitchenLaundry.jpg"
    },
    {
      "id": "ec_7b8f25e176bc52e53434f527",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166911",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166911/019d1f10-9735-741f-98c7-4197aebe6629.webp",
      "image_media": {
        "alt_text": "Dining area with table set for four, adjacent to a kitchen with bar seating.",
        "public_id": "019d1f10-9735-741f-98c7-4197aebe6629",
        "storage_key": "property/6767906449166911/019d1f10-9735-741f-98c7-4197aebe6629.webp",
        "width": 1800,
        "height": 1202
      },
      "title": "Apartment",
      "description": "Enjoy a meal at the dining table or entertain guests at the breakfast bar, which offers additional seating and overlooks the kitchen.",
      "link": "false",
      "alt_text": "Dining area with table set for four, adjacent to a kitchen with bar seating.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/SunsetSummit_Rocklin_CA_ModelKitchenDiningRoom.jpg"
    },
    {
      "id": "ec_b7d7dac7d7680335c6c16476",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166911",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166911/019d1f10-953e-75a5-bcb1-bc5716987ef3.webp",
      "image_media": {
        "alt_text": "Dining area with a high-top table and stools, decorative wall art, and a ceiling fan.",
        "public_id": "019d1f10-953e-75a5-bcb1-bc5716987ef3",
        "storage_key": "property/6767906449166911/019d1f10-953e-75a5-bcb1-bc5716987ef3.webp",
        "width": 1800,
        "height": 1202
      },
      "title": "Apartment",
      "description": "A stylish dining area featuring a high-top table with four stools, set for a meal. Decorated with wall art and a ceiling fan, this space offers a comfortable and inviting atmosphere.",
      "link": "false",
      "alt_text": "Dining area with a high-top table and stools, decorative wall art, and a ceiling fan.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/SunsetSummit_Rocklin_CA_ModelDiningRoom.jpg"
    },
    {
      "id": "ec_d9d62d2e2aa1425c0c43024c",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166911",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166911/019f6eb0-b757-76aa-ae6e-63ed4659a733.webp",
      "image_media": {
        "alt_text": "Bedroom with a queen-size bed, nightstands, and a closet with mirrored doors.",
        "public_id": "019f6eb0-b757-76aa-ae6e-63ed4659a733",
        "storage_key": "property/6767906449166911/019f6eb0-b757-76aa-ae6e-63ed4659a733.webp",
        "width": 1800,
        "height": 1202
      },
      "title": "Apartment",
      "description": "Relax in the spacious bedroom, featuring a comfortable queen-size bed, modern nightstands, and ample closet space with mirrored doors.",
      "link": "false",
      "alt_text": "Bedroom with a queen-size bed, nightstands, and a closet with mirrored doors.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/SunsetSummit_Rocklin_CA_ModelLargerBedroom.jpg"
    },
    {
      "id": "ec_34a8bb20b8ec807c67d9a279",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166911",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166911/019d23c4-0173-761b-a035-6a8726aac275.webp",
      "image_media": {
        "alt_text": "Home office setup with L-shaped desk, computer, chair, and artwork.",
        "public_id": "019d23c4-0173-761b-a035-6a8726aac275",
        "storage_key": "property/6767906449166911/019d23c4-0173-761b-a035-6a8726aac275.webp",
        "width": 1800,
        "height": 1202
      },
      "title": "Apartment",
      "description": "Create your ideal workspace in this beautifully appointed home office, complete with a comfortable desk and ample storage.",
      "link": "false",
      "alt_text": "Home office setup with L-shaped desk, computer, chair, and artwork.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/SunsetSummit_Rocklin_CA_ModelSecondBedroom.jpg"
    },
    {
      "id": "ec_0b7ab9da77558bef2e990ca5",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166911",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166911/019d23c3-fb3a-7433-9ed0-77c86d34eb84.webp",
      "image_media": {
        "alt_text": "Bathroom with double vanity, toilet, and tub with shower curtain.",
        "public_id": "019d23c3-fb3a-7433-9ed0-77c86d34eb84",
        "storage_key": "property/6767906449166911/019d23c3-fb3a-7433-9ed0-77c86d34eb84.webp",
        "width": 1800,
        "height": 1202
      },
      "title": "Apartment",
      "description": "Spacious bathroom featuring a double vanity with ample counter space, a toilet, and a tub-shower combination with a decorative curtain. Perfect for any apartment.",
      "link": "false",
      "alt_text": "Bathroom with double vanity, toilet, and tub with shower curtain.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/SunsetSummit_Rocklin_CA_ModelBathroom(1).jpg"
    },
    {
      "id": "ec_86db6b2f498bacfc28412c77",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166911",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166911/019f646a-e28a-701c-ad86-00fe4347e068.webp",
      "image_media": {
        "alt_text": "Modern kitchen with white cabinets, granite countertops, stainless steel appliances, and wood-look flooring.",
        "public_id": "019f646a-e28a-701c-ad86-00fe4347e068",
        "storage_key": "property/6767906449166911/019f646a-e28a-701c-ad86-00fe4347e068.webp",
        "width": 1800,
        "height": 1202
      },
      "title": "Apartment",
      "description": "Discover your new home in this beautifully appointed kitchen, featuring sleek white cabinetry, durable granite countertops, and a full suite of modern stainless steel appliances. Perfect for cooking and entertaining.",
      "link": "false",
      "alt_text": "Modern kitchen with white cabinets, granite countertops, stainless steel appliances, and wood-look flooring.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/SunsetSummit_Rocklin_CA_NorthPalisadeVacantKitchen.jpg"
    },
    {
      "id": "ec_e9c2d089ddb0806b8899e7af",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166911",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166911/019f646a-e39e-7639-b660-c57d8caac7a5.webp",
      "image_media": {
        "alt_text": "Laundry room with washer, dryer, and electrical panel.",
        "public_id": "019f646a-e39e-7639-b660-c57d8caac7a5",
        "storage_key": "property/6767906449166911/019f646a-e39e-7639-b660-c57d8caac7a5.webp",
        "width": 1800,
        "height": 1202
      },
      "title": "Apartment",
      "description": "In-unit laundry facilities include a washer, dryer, and convenient access to the electrical panel.",
      "link": "false",
      "alt_text": "Laundry room with washer, dryer, and electrical panel.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/SunsetSummit_Rocklin_CA_NorthPalisadeVacantLaundry.jpg"
    },
    {
      "id": "ec_4dd9615ed41aca8acf63a9c5",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166911",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166911/019f646a-e1cd-724b-b025-3821d7b44548.webp",
      "image_media": {
        "alt_text": "Living room and kitchen area with open pass-through and modern finishes.",
        "public_id": "019f646a-e1cd-724b-b025-3821d7b44548",
        "storage_key": "property/6767906449166911/019f646a-e1cd-724b-b025-3821d7b44548.webp",
        "width": 1800,
        "height": 1202
      },
      "title": "Apartment",
      "description": "Spacious living room and kitchen area featuring an open pass-through, contemporary cabinetry, and stylish wood-look flooring.",
      "link": "false",
      "alt_text": "Living room and kitchen area with open pass-through and modern finishes.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/SunsetSummit_Rocklin_CA_NorthPalisadeVacantKitchenBarDining.jpg"
    },
    {
      "id": "ec_e75ec87cfb2661270bf06770",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166911",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166911/019f646a-e286-76fa-84bc-4c4b0f776b73.webp",
      "image_media": {
        "alt_text": "Interior view of an empty apartment living room with a modern kitchen pass-through and wood-look flooring.",
        "public_id": "019f646a-e286-76fa-84bc-4c4b0f776b73",
        "storage_key": "property/6767906449166911/019f646a-e286-76fa-84bc-4c4b0f776b73.webp",
        "width": 1800,
        "height": 1202
      },
      "title": "Apartment",
      "description": "Spacious and modern apartment living area featuring wood-look floors, a pass-through kitchen, and ample natural light. Perfect for relaxing or entertaining.",
      "link": "false",
      "alt_text": "Interior view of an empty apartment living room with a modern kitchen pass-through and wood-look flooring.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/SunsetSummit_Rocklin_CA_NorthPalisadeVacantKitchenStorage.jpg"
    },
    {
      "id": "ec_24ca624bef7fdcea57043ea3",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166911",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166911/019f646a-e792-74ea-831e-ad739094dd6e.webp",
      "image_media": {
        "alt_text": "Empty living room with sliding glass door and interior door.",
        "public_id": "019f646a-e792-74ea-831e-ad739094dd6e",
        "storage_key": "property/6767906449166911/019f646a-e792-74ea-831e-ad739094dd6e.webp",
        "width": 1800,
        "height": 1202
      },
      "title": "Apartment",
      "description": "Spacious living room with wood-look flooring and a sliding glass door leading to a patio or balcony.",
      "link": "false",
      "alt_text": "Empty living room with sliding glass door and interior door.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/SunsetSummit_Rocklin_CA_NorthPalisadeVacantLivingRoomEntry.jpg"
    },
    {
      "id": "ec_3785897725ff8c0bf2f5fc90",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166911",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166911/019f646a-f66a-74bc-bd78-bdbc1ee97f71.webp",
      "image_media": {
        "alt_text": "Empty living room with wood-look flooring and a sliding glass door.",
        "public_id": "019f646a-f66a-74bc-bd78-bdbc1ee97f71",
        "storage_key": "property/6767906449166911/019f646a-f66a-74bc-bd78-bdbc1ee97f71.webp",
        "width": 1800,
        "height": 1202
      },
      "title": "Apartment",
      "description": "Spacious living area featuring wood-look flooring and access to a balcony or patio through a sliding glass door. Offers a blank canvas for personalization.",
      "link": "false",
      "alt_text": "Empty living room with wood-look flooring and a sliding glass door.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/SunsetSummit_Rocklin_CA_NorthPalisadeVacantLivingRoomHallway.jpg"
    },
    {
      "id": "ec_179850db1aa9476654db81bb",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166911",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166911/019f646a-f85b-7444-b51b-0352442a676e.webp",
      "image_media": {
        "alt_text": "Bedroom with mirrored closet doors and large carpeted area.",
        "public_id": "019f646a-f85b-7444-b51b-0352442a676e",
        "storage_key": "property/6767906449166911/019f646a-f85b-7444-b51b-0352442a676e.webp",
        "width": 1800,
        "height": 1202
      },
      "title": "Apartment",
      "description": "Spacious bedroom featuring mirrored closet doors and plush carpeting for a comfortable and elegant living space.",
      "link": "false",
      "alt_text": "Bedroom with mirrored closet doors and large carpeted area.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/SunsetSummit_Rocklin_CA_NorthPalisadeVacantPrimaryBedroom.jpg"
    },
    {
      "id": "ec_75851af1b93f2a16edca430d",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166911",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166911/019f646a-f7a8-768f-ba77-e8076d84dc5c.webp",
      "image_media": {
        "alt_text": "Bedroom with mirrored closet doors and neutral carpet.",
        "public_id": "019f646a-f7a8-768f-ba77-e8076d84dc5c",
        "storage_key": "property/6767906449166911/019f646a-f7a8-768f-ba77-e8076d84dc5c.webp",
        "width": 1800,
        "height": 1202
      },
      "title": "Apartment",
      "description": "Spacious bedroom featuring neutral carpeting, ample closet space with mirrored doors, and a doorway leading to a hallway.",
      "link": "false",
      "alt_text": "Bedroom with mirrored closet doors and neutral carpet.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/SunsetSummit_Rocklin_CA_NorthPalisadeVacantPrimaryBedroomHallway.jpg"
    },
    {
      "id": "ec_8667bc20c563737ae7769693",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166911",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166911/019f646a-f8c5-73dd-8f72-c4b6f0f44654.webp",
      "image_media": {
        "alt_text": "Bedroom with a window and two closets",
        "public_id": "019f646a-f8c5-73dd-8f72-c4b6f0f44654",
        "storage_key": "property/6767906449166911/019f646a-f8c5-73dd-8f72-c4b6f0f44654.webp",
        "width": 1800,
        "height": 1202
      },
      "title": "Apartment",
      "description": "Spacious bedroom featuring a large window with vertical blinds and two sliding door closets for ample storage.",
      "link": "false",
      "alt_text": "Bedroom with a window and two closets",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/SunsetSummit_Rocklin_CA_NorthPalisadeVacantSecondBedroom.jpg"
    },
    {
      "id": "ec_d5e8609414536298077010c3",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166911",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166911/019f646a-fb18-740d-8b4c-8e2dce36dc91.webp",
      "image_media": {
        "alt_text": "Double vanity bathroom with granite countertops and a bathtub/shower combo.",
        "public_id": "019f646a-fb18-740d-8b4c-8e2dce36dc91",
        "storage_key": "property/6767906449166911/019f646a-fb18-740d-8b4c-8e2dce36dc91.webp",
        "width": 1800,
        "height": 1202
      },
      "title": "Apartment",
      "description": "Spacious bathroom featuring a double vanity with granite countertops, ample storage, and a bathtub/shower combo, perfect for relaxation.",
      "link": "false",
      "alt_text": "Double vanity bathroom with granite countertops and a bathtub/shower combo.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/SunsetSummit_Rocklin_CA_NorthPalisadeVacantBathroom.jpg"
    },
    {
      "id": "ec_c19dcb4df5b85b8f04bfd7d7",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166911",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166911/019f646b-0a6a-76cc-a7e6-0397c29b28a0.webp",
      "image_media": {
        "alt_text": "Kitchen with white cabinets, granite countertops, and stainless steel appliances including a refrigerator, oven, and dishwasher.",
        "public_id": "019f646b-0a6a-76cc-a7e6-0397c29b28a0",
        "storage_key": "property/6767906449166911/019f646b-0a6a-76cc-a7e6-0397c29b28a0.webp",
        "width": 1800,
        "height": 1202
      },
      "title": "Apartment",
      "description": "Modern kitchen featuring white cabinetry, elegant granite countertops, and a full suite of stainless steel appliances, perfect for preparing meals.",
      "link": "false",
      "alt_text": "Kitchen with white cabinets, granite countertops, and stainless steel appliances including a refrigerator, oven, and dishwasher.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/SunsetSummit_Rocklin_CA_MtEverestVacantKitchen.jpg"
    },
    {
      "id": "ec_a86f1e730acaff5341990fed",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166911",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166911/019f646b-0c9a-7151-b522-fe1bf57986b6.webp",
      "image_media": {
        "alt_text": "Modern kitchen with white cabinets, granite countertops, stainless steel appliances, and a dishwasher.",
        "public_id": "019f646b-0c9a-7151-b522-fe1bf57986b6",
        "storage_key": "property/6767906449166911/019f646b-0c9a-7151-b522-fe1bf57986b6.webp",
        "width": 1800,
        "height": 1202
      },
      "title": "Apartment",
      "description": "View of a sleek, modern kitchen featuring white cabinetry, durable granite countertops, and a full suite of stainless steel appliances, including a dishwasher and refrigerator.",
      "link": "false",
      "alt_text": "Modern kitchen with white cabinets, granite countertops, stainless steel appliances, and a dishwasher.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/SunsetSummit_Rocklin_CA_MtEverestVacantKitchenBar.jpg"
    },
    {
      "id": "ec_2825660c4f2fa61ad9e03def",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166911",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166911/019f646b-0e3c-75bd-8648-49095ee91129.webp",
      "image_media": {
        "alt_text": "White GE washing machine with overhead white cabinets.",
        "public_id": "019f646b-0e3c-75bd-8648-49095ee91129",
        "storage_key": "property/6767906449166911/019f646b-0e3c-75bd-8648-49095ee91129.webp",
        "width": 1800,
        "height": 1202
      },
      "title": "Apartment",
      "description": "In-unit GE washing machine and dryer with overhead cabinetry for storage.",
      "link": "false",
      "alt_text": "White GE washing machine with overhead white cabinets.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/SunsetSummit_Rocklin_CA_MtEverestVacantLaundry.jpg"
    },
    {
      "id": "ec_fd990aa6e34068954dbe510e",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166911",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166911/019f646b-1170-73cd-8443-8473adfc73e0.webp",
      "image_media": {
        "alt_text": "Living room and kitchen area with vaulted ceilings and a ceiling fan.",
        "public_id": "019f646b-1170-73cd-8443-8473adfc73e0",
        "storage_key": "property/6767906449166911/019f646b-1170-73cd-8443-8473adfc73e0.webp",
        "width": 1800,
        "height": 1202
      },
      "title": "Apartment",
      "description": "Spacious living area featuring vaulted ceilings, a modern kitchen with a breakfast bar, and plush carpeting.",
      "link": "false",
      "alt_text": "Living room and kitchen area with vaulted ceilings and a ceiling fan.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/SunsetSummit_Rocklin_CA_MtEverestVacantDiningRoom.jpg"
    },
    {
      "id": "ec_dc3326090c4667b71befd2f0",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166911",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166911/019f646b-0fd3-7228-aa92-a9397ac0d35a.webp",
      "image_media": {
        "alt_text": "Living room and kitchen area with vaulted ceilings and a ceiling fan.",
        "public_id": "019f646b-0fd3-7228-aa92-a9397ac0d35a",
        "storage_key": "property/6767906449166911/019f646b-0fd3-7228-aa92-a9397ac0d35a.webp",
        "width": 1800,
        "height": 1202
      },
      "title": "Apartment",
      "description": "Spacious living area with an open-concept kitchen, featuring vaulted ceilings and a ceiling fan for comfort.",
      "link": "false",
      "alt_text": "Living room and kitchen area with vaulted ceilings and a ceiling fan.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/SunsetSummit_Rocklin_CA_MtEverestVacantDiningLivingRooms.jpg"
    },
    {
      "id": "ec_a1da160d02e7a87e17492cff",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166911",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166911/019f646b-1a08-76c3-a028-c8ca7ae73ec7.webp",
      "image_media": {
        "alt_text": "Empty living room with sliding glass door and entryway.",
        "public_id": "019f646b-1a08-76c3-a028-c8ca7ae73ec7",
        "storage_key": "property/6767906449166911/019f646b-1a08-76c3-a028-c8ca7ae73ec7.webp",
        "width": 1800,
        "height": 1202
      },
      "title": "Apartment",
      "description": "Spacious living area with neutral carpeting and a sliding glass door leading to the outdoors. Includes an entryway with a front door.",
      "link": "false",
      "alt_text": "Empty living room with sliding glass door and entryway.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/SunsetSummit_Rocklin_CA_MtEverestVacantLivingRoomEntry.jpg"
    },
    {
      "id": "ec_25d5be6c19ffebfd5006bfcd",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166911",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166911/019f646b-1e19-73f9-85ae-360be6d1f5b8.webp",
      "image_media": {
        "alt_text": "Bedroom with mirrored closet doors and soft carpeting.",
        "public_id": "019f646b-1e19-73f9-85ae-360be6d1f5b8",
        "storage_key": "property/6767906449166911/019f646b-1e19-73f9-85ae-360be6d1f5b8.webp",
        "width": 1800,
        "height": 1202
      },
      "title": "Apartment",
      "description": "Spacious bedroom featuring large mirrored closet doors and plush carpeting, offering a comfortable and inviting living space.",
      "link": "false",
      "alt_text": "Bedroom with mirrored closet doors and soft carpeting.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/SunsetSummit_Rocklin_CA_MtEverestVacantPrimaryBedroom.jpg"
    },
    {
      "id": "ec_c7a546323b6a6e9bf51db1bd",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166911",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166911/019f646b-2490-707f-a39d-7da33c792b8d.webp",
      "image_media": {
        "alt_text": "Bedroom with mirrored closet doors and view of an attached bathroom.",
        "public_id": "019f646b-2490-707f-a39d-7da33c792b8d",
        "storage_key": "property/6767906449166911/019f646b-2490-707f-a39d-7da33c792b8d.webp",
        "width": 1800,
        "height": 1202
      },
      "title": "Apartment",
      "description": "Spacious bedroom featuring plush carpeting, ample closet space with mirrored doors, and an adjoining bathroom with modern fixtures.",
      "link": "false",
      "alt_text": "Bedroom with mirrored closet doors and view of an attached bathroom.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/SunsetSummit_Rocklin_CA_MtEverestVacantPrimaryBedroomBathroom.jpg"
    },
    {
      "id": "ec_7eb5d90311fe5f11d827a644",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166911",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166911/019f646b-20fb-76c8-988a-ad52e783bfab.webp",
      "image_media": {
        "alt_text": "Bathroom with a sink, toilet, and bathtub/shower combo.",
        "public_id": "019f646b-20fb-76c8-988a-ad52e783bfab",
        "storage_key": "property/6767906449166911/019f646b-20fb-76c8-988a-ad52e783bfab.webp",
        "width": 1800,
        "height": 1202
      },
      "title": "Apartment",
      "description": "A clean and modern bathroom featuring a vanity with a granite countertop, a toilet, and a white bathtub with a shower.",
      "link": "false",
      "alt_text": "Bathroom with a sink, toilet, and bathtub/shower combo.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/SunsetSummit_Rocklin_CA_MtEverestVacantPrimaryBathroom.jpg"
    },
    {
      "id": "ec_f5a27206a85446c5cdfbceec",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166911",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166911/019f646b-236d-745c-ba1b-f9dc6cca1307.webp",
      "image_media": {
        "alt_text": "Bedroom with a closet and an adjoining room.",
        "public_id": "019f646b-236d-745c-ba1b-f9dc6cca1307",
        "storage_key": "property/6767906449166911/019f646b-236d-745c-ba1b-f9dc6cca1307.webp",
        "width": 1800,
        "height": 1202
      },
      "title": "Apartment",
      "description": "Empty bedroom with plush carpeting, a sliding door closet, and access to another room.",
      "link": "false",
      "alt_text": "Bedroom with a closet and an adjoining room.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/SunsetSummit_Rocklin_CA_MtEverestVacantSecondBedroom.jpg"
    },
    {
      "id": "ec_0d4bbe501aee697f32be7a11",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166911",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166911/019f646b-2fff-757c-a404-ce5bb045fce1.webp",
      "image_media": {
        "alt_text": "Empty room with carpet and blinds on the window.",
        "public_id": "019f646b-2fff-757c-a404-ce5bb045fce1",
        "storage_key": "property/6767906449166911/019f646b-2fff-757c-a404-ce5bb045fce1.webp",
        "width": 1800,
        "height": 1202
      },
      "title": "Apartment",
      "description": "A clean and empty room, ready for you to make it your own.",
      "link": "false",
      "alt_text": "Empty room with carpet and blinds on the window.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/SunsetSummit_Rocklin_CA_MtEverestVacantThirdBedroom.jpg"
    },
    {
      "id": "ec_31287efa2f7ccdc0053a8222",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166911",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166911/019f646b-2f2d-719b-9795-b800c7128810.webp",
      "image_media": {
        "alt_text": "Clean bathroom with white bathtub, toilet, and vanity with sink.",
        "public_id": "019f646b-2f2d-719b-9795-b800c7128810",
        "storage_key": "property/6767906449166911/019f646b-2f2d-719b-9795-b800c7128810.webp",
        "width": 1800,
        "height": 1202
      },
      "title": "Apartment",
      "description": "This apartment bathroom features a white bathtub, toilet, and vanity with a sink, offering a clean and functional space.",
      "link": "false",
      "alt_text": "Clean bathroom with white bathtub, toilet, and vanity with sink.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/SunsetSummit_Rocklin_CA_MtEverestVacantSecondBathroom.jpg"
    },
    {
      "id": "ec_5b8bbff774aeb7f9b96aaf0d",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166911",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166911/019f646b-39c2-768a-ac04-47bdc4a8b6a9.webp",
      "image_media": {
        "alt_text": "Sunset Summit Apartment Homes monument sign with stone facade and landscaping.",
        "public_id": "019f646b-39c2-768a-ac04-47bdc4a8b6a9",
        "storage_key": "property/6767906449166911/019f646b-39c2-768a-ac04-47bdc4a8b6a9.webp",
        "width": 1800,
        "height": 1202
      },
      "title": "Community",
      "description": "Welcome to Sunset Summit Apartment Homes, beautifully represented by our elegant monument sign featuring a stone facade and lush landscaping.",
      "link": "false",
      "alt_text": "Sunset Summit Apartment Homes monument sign with stone facade and landscaping.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/SunsetSummit_Rocklin_CA_PropertyMonumentSign.jpg"
    },
    {
      "id": "ec_bd7645d94ac8d04462a77dfa",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166911",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166911/019f646b-3d3c-7285-82d2-034485fbf70f.webp",
      "image_media": {
        "alt_text": "Sunset Summit Apartment Homes building exterior with stone bridge and water feature.",
        "public_id": "019f646b-3d3c-7285-82d2-034485fbf70f",
        "storage_key": "property/6767906449166911/019f646b-3d3c-7285-82d2-034485fbf70f.webp",
        "width": 1800,
        "height": 1202
      },
      "title": "Community",
      "description": "Welcome to Sunset Summit Apartment Homes, featuring a charming stone bridge and serene water feature, set against a beautifully landscaped community.",
      "link": "false",
      "alt_text": "Sunset Summit Apartment Homes building exterior with stone bridge and water feature.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/SunsetSummit_Rocklin_CA_ClubhouseEntry.jpg"
    },
    {
      "id": "ec_28511f80224ec7043c62c388",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166911",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166911/019f646b-4c49-774e-8381-069bbe1a133c.webp",
      "image_media": {
        "alt_text": "A serene courtyard with a multi-tiered rock waterfall and lush landscaping.",
        "public_id": "019f646b-4c49-774e-8381-069bbe1a133c",
        "storage_key": "property/6767906449166911/019f646b-4c49-774e-8381-069bbe1a133c.webp",
        "width": 1800,
        "height": 1202
      },
      "title": "Community",
      "description": "Enjoy the tranquil beauty of our courtyard, featuring a stunning rock waterfall and vibrant greenery, creating a peaceful oasis.",
      "link": "false",
      "alt_text": "A serene courtyard with a multi-tiered rock waterfall and lush landscaping.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/SunsetSummit_Rocklin_CA_ClubhouseEntryFountain.jpg"
    },
    {
      "id": "ec_e17b93c52e42403b30480ac5",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166911",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166911/019f646b-517a-764a-870e-ad1ba346f612.webp",
      "image_media": {
        "alt_text": "Stone pathway leading to the building entrance with landscaping and a water feature.",
        "public_id": "019f646b-517a-764a-870e-ad1ba346f612",
        "storage_key": "property/6767906449166911/019f646b-517a-764a-870e-ad1ba346f612.webp",
        "width": 1800,
        "height": 1202
      },
      "title": "Community",
      "description": "Welcome to our community! Enjoy the scenic stone pathway leading to the building entrance, surrounded by lush landscaping and a tranquil water feature.",
      "link": "false",
      "alt_text": "Stone pathway leading to the building entrance with landscaping and a water feature.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/SunsetSummit_Rocklin_CA_ClubhouseEntryBridge.jpg"
    },
    {
      "id": "ec_1a108b1354f333863e57f24a",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166911",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166911/019d1c14-84e7-7248-8902-12a26a34fd99.webp",
      "image_media": {
        "alt_text": "The leasing office or community lounge with blue seating and a map of the property.",
        "public_id": "019d1c14-84e7-7248-8902-12a26a34fd99",
        "storage_key": "property/6767906449166911/019d1c14-84e7-7248-8902-12a26a34fd99.webp",
        "width": 1800,
        "height": 1202
      },
      "title": "Community",
      "description": "Welcome to the leasing office or community lounge, featuring comfortable blue seating and a display showcasing the property's layout and available units.",
      "link": "false",
      "alt_text": "The leasing office or community lounge with blue seating and a map of the property.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/SunsetSummit_Rocklin_CA_ClubhouseFoyerSeating.jpg"
    },
    {
      "id": "ec_90507316a51e3ca516d3b193",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166911",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166911/019d1c14-84d3-75de-a111-b6d520b71683.webp",
      "image_media": {
        "alt_text": "Modern kitchen island with granite countertop and bar stools, stainless steel appliances, and grey cabinets.",
        "public_id": "019d1c14-84d3-75de-a111-b6d520b71683",
        "storage_key": "property/6767906449166911/019d1c14-84d3-75de-a111-b6d520b71683.webp",
        "width": 1800,
        "height": 1202
      },
      "title": "Apartment",
      "description": "Enjoy cooking and entertaining in this stylish kitchen, featuring a large island, granite countertops, and sleek grey cabinetry.",
      "link": "false",
      "alt_text": "Modern kitchen island with granite countertop and bar stools, stainless steel appliances, and grey cabinets.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/SunsetSummit_Rocklin_CA_ClubhouseInteriorKitchen.jpg"
    },
    {
      "id": "ec_8bb0cb88d1eb87ee6cb2cdec",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166911",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166911/019d1c14-8553-704c-9218-0a81549ebb02.webp",
      "image_media": {
        "alt_text": "Business center with desks, computers, and chairs.",
        "public_id": "019d1c14-8553-704c-9218-0a81549ebb02",
        "storage_key": "property/6767906449166911/019d1c14-8553-704c-9218-0a81549ebb02.webp",
        "width": 1800,
        "height": 1203
      },
      "title": "Community",
      "description": "Stay connected and productive in our modern business center, featuring high-speed internet and comfortable workstations.",
      "link": "false",
      "alt_text": "Business center with desks, computers, and chairs.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/SunsetSummit_Rocklin_CA_ClubhouseBusinessCenter.jpg"
    },
    {
      "id": "ec_62fb9154d1f03562de2b3b87",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166911",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166911/019d1ee1-2696-7676-9a09-d3c43579e433.webp",
      "image_media": {
        "alt_text": "Gym with dumbbells, exercise machines, exercise balls, and a weight bench.",
        "public_id": "019d1ee1-2696-7676-9a09-d3c43579e433",
        "storage_key": "property/6767906449166911/019d1ee1-2696-7676-9a09-d3c43579e433.webp",
        "width": 1800,
        "height": 1203
      },
      "title": "Community",
      "description": "Stay active in our fully-equipped fitness center. Features free weights, cardio machines, and strength training equipment.",
      "link": "false",
      "alt_text": "Gym with dumbbells, exercise machines, exercise balls, and a weight bench.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/SunsetSummit_Rocklin_CA_FitnessCenter.jpg"
    },
    {
      "id": "ec_7ba32816c0bdf9c3076554e7",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166911",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166911/019d1ee1-25d6-7619-b9d3-4cf17a03711a.webp",
      "image_media": {
        "alt_text": "Fitness center with treadmills, ellipticals, weight bench, and dumbbells.",
        "public_id": "019d1ee1-25d6-7619-b9d3-4cf17a03711a",
        "storage_key": "property/6767906449166911/019d1ee1-25d6-7619-b9d3-4cf17a03711a.webp",
        "width": 1800,
        "height": 1203
      },
      "title": "Community",
      "description": "Stay active in our fully equipped fitness center, featuring cardio machines, free weights, and a strength training station. Your well-being is our priority.",
      "link": "false",
      "alt_text": "Fitness center with treadmills, ellipticals, weight bench, and dumbbells.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/SunsetSummit_Rocklin_CA_FitnessCenterEquipment(1).jpg"
    },
    {
      "id": "ec_bd660dc98e4a0e9ef4c8d814",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166911",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166911/019d1c14-84eb-72af-9a1a-f0f9c690ff91.webp",
      "image_media": {
        "alt_text": "Package lockers with a digital interface",
        "public_id": "019d1c14-84eb-72af-9a1a-f0f9c690ff91",
        "storage_key": "property/6767906449166911/019d1c14-84eb-72af-9a1a-f0f9c690ff91.webp",
        "width": 1800,
        "height": 1202
      },
      "title": "Community",
      "description": "Secure and convenient package lockers are available for residents, featuring a digital interface for easy access and retrieval.",
      "link": "false",
      "alt_text": "Package lockers with a digital interface",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/SunsetSummit_Rocklin_CA_AmazonHubPackageCenter.jpg"
    },
    {
      "id": "ec_396329862e52e2a018070d6e",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166911",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166911/019d1ee1-2509-71cc-82c1-fdf1c1fac7c7.webp",
      "image_media": {
        "alt_text": "Indoor hot tub with wood-paneled ceiling and tiled walls.",
        "public_id": "019d1ee1-2509-71cc-82c1-fdf1c1fac7c7",
        "storage_key": "property/6767906449166911/019d1ee1-2509-71cc-82c1-fdf1c1fac7c7.webp",
        "width": 1200,
        "height": 798
      },
      "title": "Community",
      "description": "Relax and unwind in the community's indoor hot tub, featuring a soothing atmosphere and comfortable seating.",
      "link": "false",
      "alt_text": "Indoor hot tub with wood-paneled ceiling and tiled walls.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/Rocklin_CA_IndoorSpa01(1).jpg"
    },
    {
      "id": "ec_d20e3289b17e3afc7d529420",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166911",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166911/019f646b-4f1e-742e-b807-3242f9d72cad.webp",
      "image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and tables in front of a building.",
        "public_id": "019f646b-4f1e-742e-b807-3242f9d72cad",
        "storage_key": "property/6767906449166911/019f646b-4f1e-742e-b807-3242f9d72cad.webp",
        "width": 1800,
        "height": 1202
      },
      "title": "Community",
      "description": "Relax by the sparkling swimming pool, perfect for a sunny afternoon. Lounge chairs and tables are available for your comfort and convenience.",
      "link": "false",
      "alt_text": "Outdoor swimming pool with lounge chairs and tables in front of a building.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/SunsetSummit_Rocklin_CA_SwimmingPoolClubhouseExterior.jpg"
    },
    {
      "id": "ec_cdc683bd25f1e8d4300478b4",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166911",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166911/019f646b-5cc5-733a-a791-d5a3ea3e35fc.webp",
      "image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and umbrellas in front of a building.",
        "public_id": "019f646b-5cc5-733a-a791-d5a3ea3e35fc",
        "storage_key": "property/6767906449166911/019f646b-5cc5-733a-a791-d5a3ea3e35fc.webp",
        "width": 1800,
        "height": 1202
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in the sparkling outdoor swimming pool, surrounded by comfortable lounge chairs and shaded umbrellas.",
      "link": "false",
      "alt_text": "Outdoor swimming pool with lounge chairs and umbrellas in front of a building.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/SunsetSummit_Rocklin_CA_SwimmingPoolClubhouseandFurniture.jpg"
    },
    {
      "id": "ec_3620950b9a737a8adbbbc166",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166911",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166911/019f646b-5e57-74e8-affa-a4de11ad0e8c.webp",
      "image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and umbrellas",
        "public_id": "019f646b-5e57-74e8-affa-a4de11ad0e8c",
        "storage_key": "property/6767906449166911/019f646b-5e57-74e8-affa-a4de11ad0e8c.webp",
        "width": 1800,
        "height": 1202
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our sparkling outdoor swimming pool, complete with comfortable lounge chairs and shaded seating areas.",
      "link": "false",
      "alt_text": "Outdoor swimming pool with lounge chairs and umbrellas",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/SunsetSummit_Rocklin_CA_SwimmingPoolView.jpg"
    },
    {
      "id": "ec_084087ea7573d3ddd8765fe4",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166911",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166911/019f646b-64c4-745b-948e-847ec63ee474.webp",
      "image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and tables under umbrellas.",
        "public_id": "019f646b-64c4-745b-948e-847ec63ee474",
        "storage_key": "property/6767906449166911/019f646b-64c4-745b-948e-847ec63ee474.webp",
        "width": 1800,
        "height": 1202
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our sparkling swimming pool, surrounded by lush greenery and comfortable seating areas.",
      "link": "false",
      "alt_text": "Outdoor swimming pool with lounge chairs and tables under umbrellas.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/SunsetSummit_Rocklin_CA_SwimmingPoolLounges.jpg"
    },
    {
      "id": "ec_e49f7304146361da6edb994d",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166911",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166911/019f646b-67b3-7049-bcfc-c774fc468f08.webp",
      "image_media": {
        "alt_text": "Playground equipment and benches under a large oak tree.",
        "public_id": "019f646b-67b3-7049-bcfc-c774fc468f08",
        "storage_key": "property/6767906449166911/019f646b-67b3-7049-bcfc-c774fc468f08.webp",
        "width": 1800,
        "height": 1202
      },
      "title": "Community",
      "description": "Enjoy outdoor fun at our community playground, complete with slides, climbing structures, and shaded seating for parents. Perfect for family recreation.",
      "link": "false",
      "alt_text": "Playground equipment and benches under a large oak tree.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/SunsetSummit_Rocklin_CA_PlaygroundSeating.jpg"
    },
    {
      "id": "ec_dd5026599b2e609e1b900bdd",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166911",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166911/019f646b-6a81-73ad-ae0a-2c35a934255d.webp",
      "image_media": {
        "alt_text": "Playground with slide, swings, and climbing structure under a large oak tree.",
        "public_id": "019f646b-6a81-73ad-ae0a-2c35a934255d",
        "storage_key": "property/6767906449166911/019f646b-6a81-73ad-ae0a-2c35a934255d.webp",
        "width": 1800,
        "height": 1202
      },
      "title": "Community",
      "description": "Enjoy outdoor fun at our community playground, perfect for children to play and explore under the shade of a mature oak tree.",
      "link": "false",
      "alt_text": "Playground with slide, swings, and climbing structure under a large oak tree.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/SunsetSummit_Rocklin_CA_Playground.jpg"
    },
    {
      "id": "ec_eda643b011bd851e7a641062",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166911",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166911/019d1ee1-26a0-732c-8683-4f2e38443cb0.webp",
      "image_media": {
        "alt_text": "Signage for the dog park with an arrow pointing left.",
        "public_id": "019d1ee1-26a0-732c-8683-4f2e38443cb0",
        "storage_key": "property/6767906449166911/019d1ee1-26a0-732c-8683-4f2e38443cb0.webp",
        "width": 1800,
        "height": 1202
      },
      "title": "Community",
      "description": "Designated dog park area for residents and their pets.",
      "link": "false",
      "alt_text": "Signage for the dog park with an arrow pointing left.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/SunsetSummit_Rocklin_CA_DogParkSign.jpg"
    },
    {
      "id": "ec_a87976890dd58d8267096534",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166911",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166911/019f646b-7372-76ee-bb5a-297ab23b63b7.webp",
      "image_media": {
        "alt_text": "Dog park with agility tunnel and bench within a multifamily property.",
        "public_id": "019f646b-7372-76ee-bb5a-297ab23b63b7",
        "storage_key": "property/6767906449166911/019f646b-7372-76ee-bb5a-297ab23b63b7.webp",
        "width": 1800,
        "height": 1202
      },
      "title": "Community",
      "description": "Enjoy our community dog park, complete with an agility tunnel and seating area, perfect for your furry friends.",
      "link": "false",
      "alt_text": "Dog park with agility tunnel and bench within a multifamily property.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/SunsetSummit_Rocklin_CA_DogPark.jpg"
    },
    {
      "id": "ec_f22698d62632d69a650036d4",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166911",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166911/019f646b-742a-7224-9165-d86b7fcffc1e.webp",
      "image_media": {
        "alt_text": "Exterior of apartment building with lush landscaping and blooming trees.",
        "public_id": "019f646b-742a-7224-9165-d86b7fcffc1e",
        "storage_key": "property/6767906449166911/019f646b-742a-7224-9165-d86b7fcffc1e.webp",
        "width": 1800,
        "height": 1202
      },
      "title": "Community",
      "description": "Beautifully maintained grounds with vibrant flowering trees and manicured bushes surround the building exterior.",
      "link": "false",
      "alt_text": "Exterior of apartment building with lush landscaping and blooming trees.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/SunsetSummit_Rocklin_CA_BuildingExteriorParking.jpg"
    },
    {
      "id": "ec_3d8546fbe80c34d4ecfd95e2",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166911",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166911/019f646b-7be9-7796-8ae2-eaefb3367e82.webp",
      "image_media": {
        "alt_text": "Exterior view of apartment buildings with balconies and walkways.",
        "public_id": "019f646b-7be9-7796-8ae2-eaefb3367e82",
        "storage_key": "property/6767906449166911/019f646b-7be9-7796-8ae2-eaefb3367e82.webp",
        "width": 1800,
        "height": 1202
      },
      "title": "Community",
      "description": "Beautifully maintained apartment buildings featuring private balconies, scenic walkways, and lush landscaping.",
      "link": "false",
      "alt_text": "Exterior view of apartment buildings with balconies and walkways.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/SunsetSummit_Rocklin_CA_BuildingExteriorEntries.jpg"
    },
    {
      "id": "ec_ca539515249e0c1298437f71",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166911",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166911/019f646b-84ff-77a8-9ba6-21ea4daff4af.webp",
      "image_media": {
        "alt_text": "Pathways and landscaping between apartment buildings, with trees and flowering bushes.",
        "public_id": "019f646b-84ff-77a8-9ba6-21ea4daff4af",
        "storage_key": "property/6767906449166911/019f646b-84ff-77a8-9ba6-21ea4daff4af.webp",
        "width": 1800,
        "height": 1202
      },
      "title": "Community",
      "description": "Explore the serene pathways and lush landscaping, featuring mature trees and vibrant flowering bushes, that connect the apartment buildings.",
      "link": "false",
      "alt_text": "Pathways and landscaping between apartment buildings, with trees and flowering bushes.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/SunsetSummit_Rocklin_CA_WalkingPath.jpg"
    },
    {
      "id": "ec_b2f1974844dc5d4f6f6f2eec",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166911",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166911/019f646b-8843-7749-92e0-2b177bae5b62.webp",
      "image_media": {
        "alt_text": "Exterior view of apartment buildings with balconies and landscaping.",
        "public_id": "019f646b-8843-7749-92e0-2b177bae5b62",
        "storage_key": "property/6767906449166911/019f646b-8843-7749-92e0-2b177bae5b62.webp",
        "width": 1800,
        "height": 1202
      },
      "title": "Community",
      "description": "Exterior view of apartment buildings featuring balconies, well-maintained landscaping, and a serene ambiance.",
      "link": "false",
      "alt_text": "Exterior view of apartment buildings with balconies and landscaping.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/SunsetSummit_Rocklin_CA_PatiosandDecks.jpg"
    },
    {
      "id": "ec_06ea28678eb72980b0c3d93d",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166911",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166911/019f646b-8c8a-7278-9645-fb955fbde459.webp",
      "image_media": {
        "alt_text": "Exterior view of apartment buildings with lush landscaping and walkways.",
        "public_id": "019f646b-8c8a-7278-9645-fb955fbde459",
        "storage_key": "property/6767906449166911/019f646b-8c8a-7278-9645-fb955fbde459.webp",
        "width": 1800,
        "height": 1202
      },
      "title": "Community",
      "description": "Experience comfortable living in our community, surrounded by beautiful greenery and well-maintained grounds.",
      "link": "false",
      "alt_text": "Exterior view of apartment buildings with lush landscaping and walkways.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/SunsetSummit_Rocklin_CA_CommunityLandscaping.jpg"
    },
    {
      "id": "ec_ef035b25c010fd737d2aac63",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166911",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166911/019f646b-9058-7561-ae7a-8fa4010d46b6.webp",
      "image_media": {
        "alt_text": "Exterior of apartment building with manicured lawns and trees.",
        "public_id": "019f646b-9058-7561-ae7a-8fa4010d46b6",
        "storage_key": "property/6767906449166911/019f646b-9058-7561-ae7a-8fa4010d46b6.webp",
        "width": 1800,
        "height": 1202
      },
      "title": "Community",
      "description": "Beautifully maintained grounds surround this apartment building, offering a peaceful and inviting atmosphere.",
      "link": "false",
      "alt_text": "Exterior of apartment building with manicured lawns and trees.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/SunsetSummit_Rocklin_CA_GreenSpace.jpg"
    },
    {
      "id": "ec_6a92642afb74bb649e5a6b0f",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166911",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166911/019f646b-8f93-7781-bf15-bb96664bbf06.webp",
      "image_media": {
        "alt_text": "Apartment building exterior with covered parking and trees.",
        "public_id": "019f646b-8f93-7781-bf15-bb96664bbf06",
        "storage_key": "property/6767906449166911/019f646b-8f93-7781-bf15-bb96664bbf06.webp",
        "width": 1800,
        "height": 1202
      },
      "title": "Community",
      "description": "Exterior view of apartment buildings featuring covered parking spaces and mature trees, providing a welcoming and serene environment.",
      "link": "false",
      "alt_text": "Apartment building exterior with covered parking and trees.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/SunsetSummit_Rocklin_CA_Carports.jpg"
    },
    {
      "id": "ec_1c18ed10582112c1be5afe36",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166911",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166911/019f646b-98ed-7740-a7fb-beed204cbfd4.webp",
      "image_media": {
        "alt_text": "Garages with multiple parking spots in a residential area.",
        "public_id": "019f646b-98ed-7740-a7fb-beed204cbfd4",
        "storage_key": "property/6767906449166911/019f646b-98ed-7740-a7fb-beed204cbfd4.webp",
        "width": 1800,
        "height": 1202
      },
      "title": "Community",
      "description": "Secured garages with ample parking space, offering convenience and protection for your vehicle.",
      "link": "false",
      "alt_text": "Garages with multiple parking spots in a residential area.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/SunsetSummit_Rocklin_CA_Garages.jpg"
    }
  ],
  "neighborhood_pois": [
    {
      "id": "custom_31234853-3dad-4da0-a1a4-9dca0445c876",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166911",
      "source": "custom",
      "poi_name": "Topgolf Roseville",
      "poi_type": "Restaurants",
      "poi_address": "1700 Freedom Wy, Roseville, CA 95678, USA",
      "poi_short_description": "Sprawling entertainment venue with a high-tech driving range & swanky lounge with drinks & games.",
      "poi_long_description": "People say this restaurant offers fun golfing games, delicious appetizers, and a variety of cocktails. They highlight the reasonable prices, especially on weekdays, and the lively, high-energy atmosphere, perfect for date nights, family outings, and group gatherings. They also like the friendly and attentive service provided by the staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166911/019d08b1-5763-72f7-9e0f-6736943b2dba.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08b1-5763-72f7-9e0f-6736943b2dba",
        "storage_key": "property/6767906449166911/019d08b1-5763-72f7-9e0f-6736943b2dba.webp",
        "width": 1000,
        "height": 668
      },
      "poi_business_url": "https://topgolf.com/us/roseville/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1683471834520779019&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "topgolf-roseville",
      "poi_latitude": "38.7908306",
      "poi_longitude": "-121.2959577",
      "poi_miles_from_property": "2.4",
      "poi_walking_minutes": "54 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 916-200-1002",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166911/019d08b1-0e16-73d9-aeb2-d47d5e2e2552.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08b1-0e16-73d9-aeb2-d47d5e2e2552",
        "storage_key": "property/6767906449166911/019d08b1-0e16-73d9-aeb2-d47d5e2e2552.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ9QyJuochm4ARC3n8zbbkXBc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_5dac82f2-c243-4365-8212-2ce688eae831",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166911",
      "source": "custom",
      "poi_name": "In-N-Out Burger",
      "poi_type": "Restaurants",
      "poi_address": "1803 Taylor Rd, Roseville, CA 95661, USA",
      "poi_short_description": "Classic burger chain serving customizable burgers, hand-cut fries & shakes.",
      "poi_long_description": "People say this hamburger restaurant serves delicious animal fries, grilled cheese, and milkshakes. They highlight the fresh ingredients, affordable prices, and fast service. They also like the friendly staff and clean environment.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166911/019d08b1-57c3-7225-b842-47e1e1717306.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08b1-57c3-7225-b842-47e1e1717306",
        "storage_key": "property/6767906449166911/019d08b1-57c3-7225-b842-47e1e1717306.webp",
        "width": 1280,
        "height": 1206
      },
      "poi_business_url": "https://locations.in-n-out.com/132",
      "poi_directions_map_url": "https://maps.google.com/?cid=2664504733912924521&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "in-n-out-burger",
      "poi_latitude": "38.758269",
      "poi_longitude": "-121.259566",
      "poi_miles_from_property": "4.1",
      "poi_walking_minutes": "1 hour 33 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 800-786-1000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166911/019d08b1-0e16-73d9-aeb2-d47d5e2e2552.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08b1-0e16-73d9-aeb2-d47d5e2e2552",
        "storage_key": "property/6767906449166911/019d08b1-0e16-73d9-aeb2-d47d5e2e2552.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJv6GYqs-XwoARaQE6N_A4-iQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hamburger_restaurant"
    },
    {
      "id": "custom_f7ba22e3-0128-4c03-b9a4-34c00eb9fc52",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166911",
      "source": "custom",
      "poi_name": "The Cheesecake Factory",
      "poi_type": "Restaurants",
      "poi_address": "1127 Galleria Blvd, Roseville, CA 95678, USA",
      "poi_short_description": "American chain restaurant offering sizable portions from a vast menu including signature cheesecake",
      "poi_long_description": "People say this restaurant serves delicious cheesecake, pasta, and other dishes, with a huge variety of options. They also highlight the friendly and attentive service, and the generous portions.\n\nOther reviews mention the food can be overpriced.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166911/019d08b1-5794-70bc-863a-25df79e4907b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08b1-5794-70bc-863a-25df79e4907b",
        "storage_key": "property/6767906449166911/019d08b1-5794-70bc-863a-25df79e4907b.webp",
        "width": 1280,
        "height": 721
      },
      "poi_business_url": "https://locations.thecheesecakefactory.com/ca/roseville-140.html?utm_source=Google&utm_medium=Maps&utm_campaign=Google+Places",
      "poi_directions_map_url": "https://maps.google.com/?cid=3096057595972049366&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "the-cheesecake-factory",
      "poi_latitude": "38.773032",
      "poi_longitude": "-121.2685074",
      "poi_miles_from_property": "2.9",
      "poi_walking_minutes": "1 hour 6 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 916-781-3399",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166911/019d08b1-0e16-73d9-aeb2-d47d5e2e2552.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08b1-0e16-73d9-aeb2-d47d5e2e2552",
        "storage_key": "property/6767906449166911/019d08b1-0e16-73d9-aeb2-d47d5e2e2552.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJi038SdQhm4AR1lkQ3Ppn9yo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_99a5a376-d0a4-41e7-8410-d99ae6f1290d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166911",
      "source": "custom",
      "poi_name": "Yard House",
      "poi_type": "Restaurants",
      "poi_address": "1166 Roseville Pkwy Bldg E, Roseville, CA 95678, USA",
      "poi_short_description": "High-end sports-bar chain with a huge menu of New American fare & an extensive list of draft beers.",
      "poi_long_description": "People say this restaurant offers a wide variety of appetizers, including vampire tacos, sliders, and wings, as well as steak bowls and salmon. They also highlight the quick service, delicious drinks, and fun, lively atmosphere, and like the extensive selection of draft beers and ciders.\n\nOther reviews mention the noise level can be high.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166911/019d08b1-55f6-70aa-aaa8-3535f137928f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08b1-55f6-70aa-aaa8-3535f137928f",
        "storage_key": "property/6767906449166911/019d08b1-55f6-70aa-aaa8-3535f137928f.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.yardhouse.com/locations/ca/roseville/roseville-the-fountains/8331?cmpid=br:yh_ag:ie_ch:loc_ca:YHGMB_sn:gmb_gt:roseville-ca-8331_pl:locurl_rd:1029",
      "poi_directions_map_url": "https://maps.google.com/?cid=5817699224790651083&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "yard-house",
      "poi_latitude": "38.76887",
      "poi_longitude": "-121.270022",
      "poi_miles_from_property": "3.2",
      "poi_walking_minutes": "1 hour 12 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 916-780-9273",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166911/019d08b1-0e16-73d9-aeb2-d47d5e2e2552.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08b1-0e16-73d9-aeb2-d47d5e2e2552",
        "storage_key": "property/6767906449166911/019d08b1-0e16-73d9-aeb2-d47d5e2e2552.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJC4fub9Ehm4ARy1C2F5-evFA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "american_restaurant"
    },
    {
      "id": "custom_fa09c603-382e-4dab-8cfd-87d9fa5d153d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166911",
      "source": "custom",
      "poi_name": "Raising Cane's Chicken Fingers",
      "poi_type": "Restaurants",
      "poi_address": "1220 Galleria Blvd, Roseville, CA 95678, USA",
      "poi_short_description": "Fast-food chain specializing in fried chicken fingers, crinkle-cut fries & Texas toast.",
      "poi_long_description": "People say this fast food restaurant serves delicious chicken fingers, fried chicken, and garlic toast. They also highlight the fresh food, quick service, and friendly staff.\n\nOther reviews mention the music can be loud.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166911/019d08b1-5cee-70ce-8843-e98aeb228ff6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08b1-5cee-70ce-8843-e98aeb228ff6",
        "storage_key": "property/6767906449166911/019d08b1-5cee-70ce-8843-e98aeb228ff6.webp",
        "width": 720,
        "height": 720
      },
      "poi_business_url": "https://locations.raisingcanes.com/ca/roseville/1220-galleria-boulevard",
      "poi_directions_map_url": "https://maps.google.com/?cid=14438597957049205901&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "raising-canes-chicken-fingers",
      "poi_latitude": "38.7736002",
      "poi_longitude": "-121.2651215",
      "poi_miles_from_property": "2.8",
      "poi_walking_minutes": "1 hour 3 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 916-547-5425",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166911/019d08b1-0e16-73d9-aeb2-d47d5e2e2552.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08b1-0e16-73d9-aeb2-d47d5e2e2552",
        "storage_key": "property/6767906449166911/019d08b1-0e16-73d9-aeb2-d47d5e2e2552.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJdw1hb1whm4ARjUSZzFc0YMg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "fast_food_restaurant"
    },
    {
      "id": "custom_3efa7fe0-01de-4144-8a08-33e834800a6b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166911",
      "source": "custom",
      "poi_name": "Westfield Galleria at Roseville",
      "poi_type": "Shopping & Retail",
      "poi_address": "1151 Galleria Blvd, Roseville, CA 95678, USA",
      "poi_short_description": "Sprawling shopping mall boasting top-name stores and eateries alongside family-friendly amenities.",
      "poi_long_description": "People say this shopping center offers a wide variety of stores, including luxury brands and budget-friendly options, as well as a movie theater, play area, and food court with diverse dining choices. They highlight the clean, spacious, and well-organized layout, and the convenient parking. They also like the friendly and helpful staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166911/019d08b0-e8d1-761e-8998-201d2604adb9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08b0-e8d1-761e-8998-201d2604adb9",
        "storage_key": "property/6767906449166911/019d08b0-e8d1-761e-8998-201d2604adb9.webp",
        "width": 800,
        "height": 450
      },
      "poi_business_url": "https://www.westfield.com/en/united-states/galleriaatroseville",
      "poi_directions_map_url": "https://maps.google.com/?cid=5852009108560938456&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "westfield-galleria-at-roseville",
      "poi_latitude": "38.773542",
      "poi_longitude": "-121.26924",
      "poi_miles_from_property": "2.9",
      "poi_walking_minutes": "1 hour 6 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 916-787-2000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166911/019d08b1-13d4-740f-b794-0eb7509bb581.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08b1-13d4-740f-b794-0eb7509bb581",
        "storage_key": "property/6767906449166911/019d08b1-13d4-740f-b794-0eb7509bb581.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJhTBR8Fked0AR2AUgakeDNlE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "custom_3b513b98-14f8-42bd-a289-0967df96fae8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166911",
      "source": "custom",
      "poi_name": "Whole Foods Market",
      "poi_type": "Shopping & Retail",
      "poi_address": "1001 Galleria Blvd, Roseville, CA 95678, USA",
      "poi_short_description": "Eco-minded chain with natural & organic grocery items, housewares & other products (most sell wine).",
      "poi_long_description": "People say this grocery store offers a wide selection of healthy food, fresh produce, and amazing snacks. They also highlight the clean, bright, and welcoming atmosphere, and the helpful and friendly staff.\n\nOther reviews mention the prices can be high.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166911/019d08b1-5ecd-7347-9695-db05f2062726.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08b1-5ecd-7347-9695-db05f2062726",
        "storage_key": "property/6767906449166911/019d08b1-5ecd-7347-9695-db05f2062726.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.wholefoodsmarket.com/stores/roseville?utm_source=google&utm_medium=organic&utm_campaign=listings",
      "poi_directions_map_url": "https://maps.google.com/?cid=30447028617915124&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "whole-foods-market",
      "poi_latitude": "38.7673904",
      "poi_longitude": "-121.2672481",
      "poi_miles_from_property": "3.2",
      "poi_walking_minutes": "1 hour 13 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 916-781-5300",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166911/019d08b1-13d4-740f-b794-08b1e14753bb.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08b1-13d4-740f-b794-08b1e14753bb",
        "storage_key": "property/6767906449166911/019d08b1-13d4-740f-b794-08b1e14753bb.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJtS4AVtQhm4AR9Ko8RWkrbAA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_4fd5f771-9fa9-4e33-bd93-9c5cafba80db",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166911",
      "source": "custom",
      "poi_name": "WinCo Foods",
      "poi_type": "Shopping & Retail",
      "poi_address": "10151 Fairway Dr WinCo, Roseville, CA 95678, USA",
      "poi_short_description": "Employee-owned 24/7 supermarket chain with discounted groceries & bulk foods, plus a deli & bakery.",
      "poi_long_description": "People say this supermarket offers a wide variety of fresh produce, meats, and bulk foods, including an extensive selection of grains, nuts, and snacks. They highlight the low prices, great deals, and the well-stocked shelves. They also like the friendly and helpful staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166911/019d08b1-5f40-7588-89c4-01584eabe766.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08b1-5f40-7588-89c4-01584eabe766",
        "storage_key": "property/6767906449166911/019d08b1-5f40-7588-89c4-01584eabe766.webp",
        "width": 1280,
        "height": 884
      },
      "poi_business_url": "http://www.wincofoods.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3355687902784976035&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "winco-foods",
      "poi_latitude": "38.7851269",
      "poi_longitude": "-121.27854",
      "poi_miles_from_property": "1.9",
      "poi_walking_minutes": "43 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 916-783-6090",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166911/019d08b1-13d4-740f-b794-08b1e14753bb.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08b1-13d4-740f-b794-08b1e14753bb",
        "storage_key": "property/6767906449166911/019d08b1-13d4-740f-b794-08b1e14753bb.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJSxH4Fekhm4ARo_SSTl7MkS4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "supermarket"
    },
    {
      "id": "custom_44e27030-a37d-4fc0-898d-c2aa1320b380",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166911",
      "source": "custom",
      "poi_name": "Trader Joe's",
      "poi_type": "Shopping & Retail",
      "poi_address": "1117 Roseville Square, Roseville, CA 95678, USA",
      "poi_short_description": "Grocery chain with a variety of signature items, plus produce, dairy & more (most sell wine & beer).",
      "poi_long_description": "People say this grocery store offers a wide variety of unique and delicious foods, including organic produce and European imports. They highlight the affordable prices and the fun, lively atmosphere with music and singing shoppers. They also like the friendly, helpful staff who provide excellent service, even carrying heavy bags to cars.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166911/019d08b1-5ffd-7449-a9e7-14f92908abd3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08b1-5ffd-7449-a9e7-14f92908abd3",
        "storage_key": "property/6767906449166911/019d08b1-5ffd-7449-a9e7-14f92908abd3.webp",
        "width": 1280,
        "height": 1174
      },
      "poi_business_url": "https://locations.traderjoes.com/ca/roseville/80/?utm_source=gmb&utm_medium=organic&utm_campaign=local",
      "poi_directions_map_url": "https://maps.google.com/?cid=13791252673358186453&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "trader-joes",
      "poi_latitude": "38.7462886",
      "poi_longitude": "-121.274886",
      "poi_miles_from_property": "4.8",
      "poi_walking_minutes": "1 hour 48 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 916-784-9084",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166911/019d08b1-13d4-740f-b794-08b1e14753bb.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08b1-13d4-740f-b794-08b1e14753bb",
        "storage_key": "property/6767906449166911/019d08b1-13d4-740f-b794-08b1e14753bb.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJYTRdVD0gm4AR1ccruzxfZL8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_b5ee13c0-165c-41d3-a1a8-310b2b703cea",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166911",
      "source": "custom",
      "poi_name": "The Home Depot",
      "poi_type": "Shopping & Retail",
      "poi_address": "10001 Fairway Dr, Roseville, CA 95678, USA",
      "poi_short_description": "Chain home improvement retailer for tools, appliances & other products (some offer truck rentals).",
      "poi_long_description": "People say this home improvement store has a wide selection of products and equipment rentals. They also highlight the friendly and helpful staff, and the well-maintained garden area.\n\nOther reviews mention the parking lot can be messy.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166911/019d08b1-6335-710a-8242-221a54e7735e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08b1-6335-710a-8242-221a54e7735e",
        "storage_key": "property/6767906449166911/019d08b1-6335-710a-8242-221a54e7735e.webp",
        "width": 640,
        "height": 480
      },
      "poi_business_url": "https://www.homedepot.com/l/Stanford-Ranch/CA/Roseville/95678/6688?emt=MSGMBGoogleMaps",
      "poi_directions_map_url": "https://maps.google.com/?cid=8682696703861530084&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "the-home-depot",
      "poi_latitude": "38.783274",
      "poi_longitude": "-121.2744493",
      "poi_miles_from_property": "2.1",
      "poi_walking_minutes": "48 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 916-787-0201",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166911/019d08b1-13d4-740f-b794-0eb7509bb581.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08b1-13d4-740f-b794-0eb7509bb581",
        "storage_key": "property/6767906449166911/019d08b1-13d4-740f-b794-0eb7509bb581.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJIUrsBeghm4AR5B0fNqYif3g",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "home_improvement_store"
    },
    {
      "id": "custom_f2dc96d1-85d7-4556-8823-a26822f7518d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166911",
      "source": "custom",
      "poi_name": "Sierra College",
      "poi_type": "Education",
      "poi_address": "5100 Sierra College Blvd, Rocklin, CA 95677, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166911/019d08b0-a495-727b-bb54-89f4448df5b0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08b0-a495-727b-bb54-89f4448df5b0",
        "storage_key": "property/6767906449166911/019d08b0-a495-727b-bb54-89f4448df5b0.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.sierracollege.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7035051336990397408&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "sierra-college",
      "poi_latitude": "38.7909585",
      "poi_longitude": "-121.2108548",
      "poi_miles_from_property": "4.7",
      "poi_walking_minutes": "1 hour 49 mins",
      "poi_biking_minutes": "31 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 916-624-3333",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166911/019d08b1-13e3-705d-bc0d-2dafd41f38bd.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08b1-13e3-705d-bc0d-2dafd41f38bd",
        "storage_key": "property/6767906449166911/019d08b1-13e3-705d-bc0d-2dafd41f38bd.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJJ737sfwem4AR4BPz7eqFoWE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_f7bf0b3e-0314-47ab-82f2-71224fe2c3a4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166911",
      "source": "custom",
      "poi_name": "Jessup University",
      "poi_type": "Education",
      "poi_address": "2121 University Ave, Rocklin, CA 95765, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166911/019d08b0-f9bf-77c8-8c79-471513581f2c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08b0-f9bf-77c8-8c79-471513581f2c",
        "storage_key": "property/6767906449166911/019d08b0-f9bf-77c8-8c79-471513581f2c.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://jessup.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13733206301315708494&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "jessup-university",
      "poi_latitude": "38.8203949",
      "poi_longitude": "-121.292457",
      "poi_miles_from_property": "1.5",
      "poi_walking_minutes": "34 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 916-577-2200",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166911/019d08b1-13e3-705d-bc0d-2dafd41f38bd.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08b1-13e3-705d-bc0d-2dafd41f38bd",
        "storage_key": "property/6767906449166911/019d08b1-13e3-705d-bc0d-2dafd41f38bd.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJrVlwI0cim4ARTjYUkV4mlr4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_76bc5016-abae-4b76-98e3-53315fe7541e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166911",
      "source": "custom",
      "poi_name": "Roseville Golfland Sunsplash",
      "poi_type": "Entertainment",
      "poi_address": "1893 Taylor Rd, Roseville, CA 95661, USA",
      "poi_short_description": "Amusement chain featuring mini golf courses & arcades, some branches with water slides & laser tag.",
      "poi_long_description": "People say this amusement park offers a variety of fun activities, including mini golf, water slides, go-karts, and an arcade. They also highlight the family-friendly atmosphere, the friendly staff, and the well-maintained facilities.\n\nOther reviews mention the food can be expensive.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166911/019d08b1-6636-703c-bb35-117d771ac8e8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08b1-6636-703c-bb35-117d771ac8e8",
        "storage_key": "property/6767906449166911/019d08b1-6636-703c-bb35-117d771ac8e8.webp",
        "width": 1140,
        "height": 755
      },
      "poi_business_url": "http://www.golfland.com/roseville",
      "poi_directions_map_url": "https://maps.google.com/?cid=13763917757911760307&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "roseville-golfland-sunsplash",
      "poi_latitude": "38.7615002",
      "poi_longitude": "-121.2579841",
      "poi_miles_from_property": "4",
      "poi_walking_minutes": "1 hour 31 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 916-784-1273",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166911/019d08b1-0e14-7534-bfa0-5ba263f04505.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08b1-0e14-7534-bfa0-5ba263f04505",
        "storage_key": "property/6767906449166911/019d08b1-0e14-7534-bfa0-5ba263f04505.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJfQmp14Ufm4ARs30FxkZCA78",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "amusement_park"
    },
    {
      "id": "custom_981bd0a0-fbda-4031-a7c7-d7306b144b14",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166911",
      "source": "custom",
      "poi_name": "Vernon Street Town Square",
      "poi_type": "Entertainment",
      "poi_address": "311 Vernon St, Roseville, CA 95678, USA",
      "poi_short_description": "Family-friendly event destination featuring a splash pad and concerts throughout the year.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166911/019d08b1-671b-71af-b375-4d4e7967790e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08b1-671b-71af-b375-4d4e7967790e",
        "storage_key": "property/6767906449166911/019d08b1-671b-71af-b375-4d4e7967790e.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.roseville.ca.us/parks/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10388886401199227140&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "vernon-street-town-square",
      "poi_latitude": "38.747918",
      "poi_longitude": "-121.2844672",
      "poi_miles_from_property": "5.2",
      "poi_walking_minutes": "1 hour 56 mins",
      "poi_biking_minutes": "29 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 916-772-7529",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166911/019d08b1-0e14-7534-bfa0-5ba263f04505.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08b1-0e14-7534-bfa0-5ba263f04505",
        "storage_key": "property/6767906449166911/019d08b1-0e14-7534-bfa0-5ba263f04505.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJC3cGlzggm4ARBMFdoyO9LJA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "plaza"
    },
    {
      "id": "custom_e25b4687-37cf-41ee-a337-2e8c92ce555e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166911",
      "source": "custom",
      "poi_name": "Sierra College Natural History Museum - SCNHM",
      "poi_type": "Entertainment",
      "poi_address": "5100 Sierra College Blvd, Rocklin, CA 95677, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166911/019d08b1-676e-73fd-a7fd-deb99943a6b2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08b1-676e-73fd-a7fd-deb99943a6b2",
        "storage_key": "property/6767906449166911/019d08b1-676e-73fd-a7fd-deb99943a6b2.webp",
        "width": 1280,
        "height": 872
      },
      "poi_business_url": "https://www.sierracollege.edu/campus-life/things-to-do-on-campus/natural-history-museum/",
      "poi_directions_map_url": "https://maps.google.com/?cid=180864048181489185&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "sierra-college-natural-history-museum---scnhm",
      "poi_latitude": "38.7907223",
      "poi_longitude": "-121.2138816",
      "poi_miles_from_property": "4.6",
      "poi_walking_minutes": "1 hour 46 mins",
      "poi_biking_minutes": "31 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 916-660-7923",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166911/019d08b1-13e1-701d-94bb-d8e9eed8e2af.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08b1-13e1-701d-94bb-d8e9eed8e2af",
        "storage_key": "property/6767906449166911/019d08b1-13e1-701d-94bb-d8e9eed8e2af.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJscOnwvwem4ARIS5_wOSOggI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_cc33e3f2-6f75-4ea0-aa09-be3966697868",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166911",
      "source": "custom",
      "poi_name": "Maidu Museum & Historic Site",
      "poi_type": "Entertainment",
      "poi_address": "1970 Johnson Ranch Dr, Roseville, CA 95661, USA",
      "poi_short_description": "This Maidu museum features interactive exhibits, tours & trails with historic petroglyphs & mortars.",
      "poi_long_description": "This Maidu museum features interactive exhibits, tours & trails with historic petroglyphs & mortars.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166911/019d08b1-69b6-721f-ad68-6e5c61a1325e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08b1-69b6-721f-ad68-6e5c61a1325e",
        "storage_key": "property/6767906449166911/019d08b1-69b6-721f-ad68-6e5c61a1325e.webp",
        "width": 800,
        "height": 532
      },
      "poi_business_url": "https://www.roseville.ca.us/residents/maidu_museum_historic_site",
      "poi_directions_map_url": "https://maps.google.com/?cid=12030190500831605979&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "maidu-museum--historic-site",
      "poi_latitude": "38.73852",
      "poi_longitude": "-121.2457804",
      "poi_miles_from_property": "6.2",
      "poi_walking_minutes": "2 hours 19 mins",
      "poi_biking_minutes": "36 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 916-774-5934",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166911/019d08b1-13e1-701d-94bb-d8e9eed8e2af.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08b1-13e1-701d-94bb-d8e9eed8e2af",
        "storage_key": "property/6767906449166911/019d08b1-13e1-701d-94bb-d8e9eed8e2af.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJM3cp0-Efm4AR27RYloXS86Y",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_76c37a1f-fc47-4c9e-bcfd-1d0c104432fc",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166911",
      "source": "custom",
      "poi_name": "Roseville Utility Exploration Center",
      "poi_type": "Entertainment",
      "poi_address": "1501 Pleasant Grove Blvd, Roseville, CA 95747, USA",
      "poi_short_description": "Learning center with creative exhibits on sustainability topics such as energy & water conservation.",
      "poi_long_description": "Learning center with creative exhibits on sustainability topics such as energy & water conservation.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166911/019d08b1-6cfa-724d-a7b8-1689f2db5ac6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08b1-6cfa-724d-a7b8-1689f2db5ac6",
        "storage_key": "property/6767906449166911/019d08b1-6cfa-724d-a7b8-1689f2db5ac6.webp",
        "width": 1200,
        "height": 800
      },
      "poi_business_url": "http://www.roseville.ca.us/explore",
      "poi_directions_map_url": "https://maps.google.com/?cid=910903833852852384&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "roseville-utility-exploration-center",
      "poi_latitude": "38.7674387",
      "poi_longitude": "-121.332085",
      "poi_miles_from_property": "5",
      "poi_walking_minutes": "1 hour 52 mins",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 916-746-1550",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166911/019d08b1-13e1-701d-94bb-d8e9eed8e2af.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08b1-13e1-701d-94bb-d8e9eed8e2af",
        "storage_key": "property/6767906449166911/019d08b1-13e1-701d-94bb-d8e9eed8e2af.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJR8ooIkAhm4ARoDhX8TUupAw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_1cff15c1-d91f-4d32-a30a-41ccc69dc2b3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166911",
      "source": "custom",
      "poi_name": "Life Time",
      "poi_type": "Health and Wellness",
      "poi_address": "1435 E Roseville Pkwy, Roseville, CA 95661, USA",
      "poi_short_description": "Gym with a cafe, an outdoor pool and spa, plus a mix of classes and personal trainers.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166911/019d08b1-6d5f-77c1-839e-1133dd0739f5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08b1-6d5f-77c1-839e-1133dd0739f5",
        "storage_key": "property/6767906449166911/019d08b1-6d5f-77c1-839e-1133dd0739f5.webp",
        "width": 640,
        "height": 640
      },
      "poi_business_url": "https://www.lifetime.life/locations/ca/roseville.html?utm_source=google&utm_medium=local&utm_campaign=google-local-club",
      "poi_directions_map_url": "https://maps.google.com/?cid=857371607747484135&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "life-time",
      "poi_latitude": "38.7619047",
      "poi_longitude": "-121.2446626",
      "poi_miles_from_property": "4.6",
      "poi_walking_minutes": "1 hour 45 mins",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 916-472-2000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166911/019d08b1-0e14-7534-bfa0-5ba263f04505.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08b1-0e14-7534-bfa0-5ba263f04505",
        "storage_key": "property/6767906449166911/019d08b1-0e14-7534-bfa0-5ba263f04505.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJj-SMM5cfm4AR51lLSO_-5Qs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_087978c3-f3ea-495b-b646-89cbc5dc8f9e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166911",
      "source": "custom",
      "poi_name": "24 Hour Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "1533 Blue Oaks Blvd, Roseville, CA 95747, USA",
      "poi_short_description": "Clean 24-hour fitness center offering weight training and cardio machines, plus personal training.",
      "poi_long_description": "People say this gym offers a wide variety of cardio equipment, machines, and classes, including Zumba, and has amenities like a sauna, cold plunge, and hot tub. They also highlight the friendly, energetic, and supportive staff, and the positive and motivating vibe.\n\nSome reviews mention the gym can be crowded.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166911/019d08b1-6dac-73f8-af85-660ffaba5623.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08b1-6dac-73f8-af85-660ffaba5623",
        "storage_key": "property/6767906449166911/019d08b1-6dac-73f8-af85-660ffaba5623.webp",
        "width": 1080,
        "height": 608
      },
      "poi_business_url": "https://www.24hourfitness.com/gyms/roseville-ca/west-roseville-super-sport",
      "poi_directions_map_url": "https://maps.google.com/?cid=6961004575732605694&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "24-hour-fitness",
      "poi_latitude": "38.7936837",
      "poi_longitude": "-121.3276887",
      "poi_miles_from_property": "3.5",
      "poi_walking_minutes": "1 hour 18 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 279-399-7106",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166911/019d08b1-0e14-7534-bfa0-5ba263f04505.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08b1-0e14-7534-bfa0-5ba263f04505",
        "storage_key": "property/6767906449166911/019d08b1-0e14-7534-bfa0-5ba263f04505.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ8ag-VlIjm4AR_iJp2Md0mmA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_d9eba9ce-fdf2-4219-be04-e97bfeb17ab3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166911",
      "source": "custom",
      "poi_name": "Villa Sport Athletic Club",
      "poi_type": "Health and Wellness",
      "poi_address": "291 Conference Center Dr, Roseville, CA 95678, USA",
      "poi_short_description": "Family-friendly fitness centre featuring a pool with a waterslide, plus a spa and a kids' club.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166911/019d08b1-740e-7052-a481-cb6ef9b59318.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08b1-740e-7052-a481-cb6ef9b59318",
        "storage_key": "property/6767906449166911/019d08b1-740e-7052-a481-cb6ef9b59318.webp",
        "width": 1200,
        "height": 800
      },
      "poi_business_url": "https://www.villasport.com/roseville/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3436146082975352668&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "villa-sport-athletic-club",
      "poi_latitude": "38.7790663",
      "poi_longitude": "-121.271663",
      "poi_miles_from_property": "3.5",
      "poi_walking_minutes": "1 hour 19 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 916-831-7070",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166911/019d08b1-0e14-7534-bfa0-5ba263f04505.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08b1-0e14-7534-bfa0-5ba263f04505",
        "storage_key": "property/6767906449166911/019d08b1-0e14-7534-bfa0-5ba263f04505.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJS90qpfghm4ARXIcYMKikry8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_81f2990e-d12d-4e0c-a54a-67085e3a35ac",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166911",
      "source": "custom",
      "poi_name": "Planet Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "6831 Lonetree Blvd, Rocklin, CA 95765, USA",
      "poi_short_description": "Chain gym with cardio and strength-training equipment, massage chairs, tanning beds, and showers.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166911/019d08b1-73f8-7589-a2a1-6b68049b5565.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08b1-73f8-7589-a2a1-6b68049b5565",
        "storage_key": "property/6767906449166911/019d08b1-73f8-7589-a2a1-6b68049b5565.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.planetfitness.com/gyms/rocklin-ca?utm_medium=organic&utm_source=extnet",
      "poi_directions_map_url": "https://maps.google.com/?cid=10254324074506971772&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "planet-fitness",
      "poi_latitude": "38.7976671",
      "poi_longitude": "-121.2899537",
      "poi_miles_from_property": "1.4",
      "poi_walking_minutes": "31 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 916-755-6015",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166911/019d08b1-0e14-7534-bfa0-5ba263f04505.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08b1-0e14-7534-bfa0-5ba263f04505",
        "storage_key": "property/6767906449166911/019d08b1-0e14-7534-bfa0-5ba263f04505.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ4x-sEZojm4ARfGq5gGqtTo4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_42b914a3-fb29-41ae-9faa-ae4490b54d06",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166911",
      "source": "custom",
      "poi_name": "VCA Loomis Basin Veterinary Clinic",
      "poi_type": "Health and Wellness",
      "poi_address": "3901 Sierra College Blvd, Loomis, CA 95650, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166911/019d08b1-7404-742d-9054-2bbcfbbe3f0d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08b1-7404-742d-9054-2bbcfbbe3f0d",
        "storage_key": "property/6767906449166911/019d08b1-7404-742d-9054-2bbcfbbe3f0d.webp",
        "width": 1280,
        "height": 719
      },
      "poi_business_url": "https://vcahospitals.com/loomis-basin?utm_source=maps&utm_medium=organic&utm_campaign=AU_935",
      "poi_directions_map_url": "https://maps.google.com/?cid=3050520726901175039&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "vca-loomis-basin-veterinary-clinic",
      "poi_latitude": "38.81533",
      "poi_longitude": "-121.207103",
      "poi_miles_from_property": "5.6",
      "poi_walking_minutes": "2 hours 6 mins",
      "poi_biking_minutes": "39 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 916-652-5816",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166911/019d08b1-0e14-7534-bfa0-5ba263f04505.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08b1-0e14-7534-bfa0-5ba263f04505",
        "storage_key": "property/6767906449166911/019d08b1-0e14-7534-bfa0-5ba263f04505.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJF-uKVdAem4AR_zLpUnCgVSo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "veterinary_care"
    },
    {
      "id": "custom_26a35385-8903-4da6-8695-3350983e788b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166911",
      "source": "custom",
      "poi_name": "Ulta Beauty",
      "poi_type": "Health and Wellness",
      "poi_address": "1232 Galleria Blvd Ste 100, Roseville, CA 95678, USA",
      "poi_short_description": "Chain with a diverse selection of cosmetics & other beauty products, plus on-site salon services.",
      "poi_long_description": "Chain with a diverse selection of cosmetics & other beauty products, plus on-site salon services.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166911/019d08b1-76e6-77be-98ca-293f832f31b2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08b1-76e6-77be-98ca-293f832f31b2",
        "storage_key": "property/6767906449166911/019d08b1-76e6-77be-98ca-293f832f31b2.webp",
        "width": 720,
        "height": 405
      },
      "poi_business_url": "https://www.ulta.com/stores/roseville-ca-103",
      "poi_directions_map_url": "https://maps.google.com/?cid=5127848378555817095&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "ulta-beauty",
      "poi_latitude": "38.773455",
      "poi_longitude": "-121.2612387",
      "poi_miles_from_property": "3",
      "poi_walking_minutes": "1 hour 8 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 916-780-1117",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166911/019d08b1-0e14-7534-bfa0-5ba263f04505.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08b1-0e14-7534-bfa0-5ba263f04505",
        "storage_key": "property/6767906449166911/019d08b1-0e14-7534-bfa0-5ba263f04505.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ0fSv930fm4ARh9zhie7GKUc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hair_salon"
    },
    {
      "id": "custom_353ec0b0-77eb-456e-808b-d16196f59002",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166911",
      "source": "custom",
      "poi_name": "In-Shape Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "2165 Sunset Blvd, Rocklin, CA 95765, USA",
      "poi_short_description": "Chain fitness center with a swimming pool, Pilates studio, and yoga studio, plus child care.",
      "poi_long_description": "People say this gym offers a large variety of equipment, a pool, a sauna, and a steam room. They also highlight the friendly staff, the beautiful views, and the good vibe.\n\nOther reviews mention the facilities can be poorly maintained.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166911/019d08b0-c2f3-7572-be94-7758d9878e0e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08b0-c2f3-7572-be94-7758d9878e0e",
        "storage_key": "property/6767906449166911/019d08b0-c2f3-7572-be94-7758d9878e0e.webp",
        "width": 1200,
        "height": 900
      },
      "poi_business_url": "https://www.inshape.com/gyms/rocklin?utm_source=G&utm_medium=Local&utm_campaign=Google-Local&utm_source=G&utm_medium=Local&utm_campaign=Google-Local",
      "poi_directions_map_url": "https://maps.google.com/?cid=18437040336201676890&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "in-shape-fitness",
      "poi_latitude": "38.8067933",
      "poi_longitude": "-121.2731016",
      "poi_miles_from_property": "0.2",
      "poi_walking_minutes": "5 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 916-435-2141",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166911/019d08b1-0e14-7534-bfa0-5ba263f04505.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08b1-0e14-7534-bfa0-5ba263f04505",
        "storage_key": "property/6767906449166911/019d08b1-0e14-7534-bfa0-5ba263f04505.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJv-qDMPkhm4ARWnjZjICG3f8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_6147ffb9-921e-46ea-a5ef-65d3c107ffab",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166911",
      "source": "custom",
      "poi_name": "Gold's Gym - Citrus Heights",
      "poi_type": "Health and Wellness",
      "poi_address": "8485 Auburn Blvd, Citrus Heights, CA 95610, USA",
      "poi_short_description": "Spacious chain gym offering a variety of exercise machines and weights including cardio options, along with friendly staff.",
      "poi_long_description": "People say this gym offers a wide variety of equipment. They highlight the gym is a decent size and the front desk staff is usually friendly. They also like the welcoming atmosphere and the willingness of members to share advice. ",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166911/019d08b1-7cae-71cc-9d89-7ea8a87925d7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08b1-7cae-71cc-9d89-7ea8a87925d7",
        "storage_key": "property/6767906449166911/019d08b1-7cae-71cc-9d89-7ea8a87925d7.webp",
        "width": 960,
        "height": 350
      },
      "poi_business_url": "http://www.goldsgym.com/citrus-heights/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11983788150103413449&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "golds-gym---citrus-heights",
      "poi_latitude": "38.7203476",
      "poi_longitude": "-121.2916771",
      "poi_miles_from_property": "7.3",
      "poi_walking_minutes": "2 hours 42 mins",
      "poi_biking_minutes": "41 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 916-241-8939",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166911/019d08b1-0e14-7534-bfa0-5ba263f04505.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08b1-0e14-7534-bfa0-5ba263f04505",
        "storage_key": "property/6767906449166911/019d08b1-0e14-7534-bfa0-5ba263f04505.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJfeXk-4nfmoARyRJzZtT3TqY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_d610e0e1-f8d8-4e36-b879-b8844fb7b971",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166911",
      "source": "custom",
      "poi_name": "Sutter Roseville Medical Center",
      "poi_type": "Health and Wellness",
      "poi_address": "1 Medical Plaza Dr, Roseville, CA 95661, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166911/019d08b0-b6a1-7161-aaad-70c8d496ff65.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08b0-b6a1-7161-aaad-70c8d496ff65",
        "storage_key": "property/6767906449166911/019d08b0-b6a1-7161-aaad-70c8d496ff65.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.sutterhealth.org/find-location/facility/sutter-roseville-medical-center-1043247063",
      "poi_directions_map_url": "https://maps.google.com/?cid=16416276433024432869&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "sutter-roseville-medical-center",
      "poi_latitude": "38.7665119",
      "poi_longitude": "-121.2493364",
      "poi_miles_from_property": "4.7",
      "poi_walking_minutes": "1 hour 44 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 916-781-1000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166911/019d08b1-1958-776a-b671-2190fdf91679.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08b1-1958-776a-b671-2190fdf91679",
        "storage_key": "property/6767906449166911/019d08b1-1958-776a-b671-2190fdf91679.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJHZKeApsfm4AR5boJTXBU0uM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_00620cf5-0c91-4da7-b14f-addbd3f89377",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166911",
      "source": "custom",
      "poi_name": "Kaiser Permanente Roseville Medical Center - Building C",
      "poi_type": "Health and Wellness",
      "poi_address": "1660 Eureka Rd, Roseville, CA 95661, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166911/019d08b1-7d94-742b-93e9-d26ce5cfdb50.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08b1-7d94-742b-93e9-d26ce5cfdb50",
        "storage_key": "property/6767906449166911/019d08b1-7d94-742b-93e9-d26ce5cfdb50.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://thrive.kaiserpermanente.org/care-near-you/northern-california/northvalley/locations/roseville-medical-center/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12837480181016674950&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "kaiser-permanente-roseville-medical-center---building-c",
      "poi_latitude": "38.7455188",
      "poi_longitude": "-121.2488626",
      "poi_miles_from_property": "5.4",
      "poi_walking_minutes": "2 hours 2 mins",
      "poi_biking_minutes": "32 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 916-784-4000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166911/019d08b1-1958-776a-b671-2190fdf91679.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08b1-1958-776a-b671-2190fdf91679",
        "storage_key": "property/6767906449166911/019d08b1-1958-776a-b671-2190fdf91679.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJfVgDhXMfm4ARhsKdcDXkJ7I",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_c6841e1c-2483-46e1-8fa7-186e19a7bfa5",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166911",
      "source": "custom",
      "poi_name": "Maidu Regional Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "1550 Maidu Dr, Roseville, CA 95661, USA",
      "poi_short_description": "A 152-acre park that includes a community center, library & museum, plus many sports facilities.",
      "poi_long_description": "People say this park offers baseball fields, softball fields, a skate park, walking trails, and a playground. They highlight the spaciousness, shade, and well-maintained facilities, as well as the convenient parking and nearby amenities like a library and community center. They also like the farmers market on Sundays.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166911/019d08b1-7f79-703d-8ada-ddadd5216036.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08b1-7f79-703d-8ada-ddadd5216036",
        "storage_key": "property/6767906449166911/019d08b1-7f79-703d-8ada-ddadd5216036.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.roseville.ca.us/government/departments/parks/parks_places/maidu_regional_park",
      "poi_directions_map_url": "https://maps.google.com/?cid=13221982917698702125&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "maidu-regional-park",
      "poi_latitude": "38.7348068",
      "poi_longitude": "-121.2526237",
      "poi_miles_from_property": "6",
      "poi_walking_minutes": "2 hours 15 mins",
      "poi_biking_minutes": "34 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 916-774-5200",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166911/019d08b1-1e6a-759b-a5d4-1e4fbed843f5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08b1-1e6a-759b-a5d4-1e4fbed843f5",
        "storage_key": "property/6767906449166911/019d08b1-1e6a-759b-a5d4-1e4fbed843f5.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ5xooih3gmoARLcu2G2nrfbc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_0fcc45f6-26df-4aa3-8e01-88d3503d0f99",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166911",
      "source": "custom",
      "poi_name": "Johnson-Springview Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "5480 5th St, Rocklin, CA 95677, USA",
      "poi_short_description": "This expansive community resource features sport courts & fields, a playground & a dog park.",
      "poi_long_description": "People say this park offers a wide variety of activities, including a disc golf course, dog park, pickleball courts, playground, skate park, soccer field, splash pad, tennis courts, and walking trails. They highlight the park's spaciousness, well-maintained facilities, and family-friendly atmosphere. They also like the clean restrooms and shaded BBQ areas.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166911/019d08b1-7ea8-771d-8eac-a064f088bbb0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08b1-7ea8-771d-8eac-a064f088bbb0",
        "storage_key": "property/6767906449166911/019d08b1-7ea8-771d-8eac-a064f088bbb0.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.rocklin.ca.us/depts/parksnrec/parks/johnson_springview_park.asp",
      "poi_directions_map_url": "https://maps.google.com/?cid=17091168952253734584&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "johnson-springview-park",
      "poi_latitude": "38.7900911",
      "poi_longitude": "-121.2447255",
      "poi_miles_from_property": "2.7",
      "poi_walking_minutes": "1 hour 2 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 916-625-5200",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166911/019d08b1-1e6a-759b-a5d4-1e4fbed843f5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08b1-1e6a-759b-a5d4-1e4fbed843f5",
        "storage_key": "property/6767906449166911/019d08b1-1e6a-759b-a5d4-1e4fbed843f5.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJkxyn8Gkfm4ARuN5E85sHMO0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_db822ca3-160d-4490-8dcf-f447264fb428",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166911",
      "source": "custom",
      "poi_name": "Harry Crabb Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "1000 Scarborough Dr, Roseville, CA 95661, USA",
      "poi_short_description": "Popular family park featuring a splash pad, as well as swings and sand volleyball courts.",
      "poi_long_description": "Visitors say this park has a great splash pad and water park, as well as volleyball courts, a baseball field, a basketball court, a tennis court, a playground, a picnic area, and soccer fields. They also highlight that the park is clean and well-maintained, with bathrooms available.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166911/019d08b1-83ae-7168-8546-66679e633c1f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08b1-83ae-7168-8546-66679e633c1f",
        "storage_key": "property/6767906449166911/019d08b1-83ae-7168-8546-66679e633c1f.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.roseville.ca.us/government/departments/parks/parks_places/crabb_park",
      "poi_directions_map_url": "https://maps.google.com/?cid=15538028085356412488&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "harry-crabb-park",
      "poi_latitude": "38.7691293",
      "poi_longitude": "-121.2346673",
      "poi_miles_from_property": "5.1",
      "poi_walking_minutes": "1 hour 57 mins",
      "poi_biking_minutes": "32 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 916-774-5748",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166911/019d08b1-1e6a-759b-a5d4-1e4fbed843f5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08b1-1e6a-759b-a5d4-1e4fbed843f5",
        "storage_key": "property/6767906449166911/019d08b1-1e6a-759b-a5d4-1e4fbed843f5.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJk348haMfm4ARSD62OTgqotc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_54dd75e6-f94a-408b-bc30-b53bd730c249",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166911",
      "source": "custom",
      "poi_name": "Mahany Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "1545 Pleasant Grove Blvd, Roseville, CA 95747, USA",
      "poi_short_description": "Expansive park with sports & aquatic centers, athletic fields & a universally accessible playground.",
      "poi_long_description": "Expansive park with sports & aquatic centers, athletic fields & a universally accessible playground.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166911/019d08b0-ee8e-757a-a90c-48ccb6d11b76.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08b0-ee8e-757a-a90c-48ccb6d11b76",
        "storage_key": "property/6767906449166911/019d08b0-ee8e-757a-a90c-48ccb6d11b76.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.roseville.ca.us/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7614086073060341684&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "mahany-park",
      "poi_latitude": "38.7674183",
      "poi_longitude": "-121.3341323",
      "poi_miles_from_property": "5.2",
      "poi_walking_minutes": "1 hour 57 mins",
      "poi_biking_minutes": "29 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 916-772-7529",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166911/019d08b1-1e6a-759b-a5d4-1e4fbed843f5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08b1-1e6a-759b-a5d4-1e4fbed843f5",
        "storage_key": "property/6767906449166911/019d08b1-1e6a-759b-a5d4-1e4fbed843f5.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJp32Y_0Ahm4ARtLcCOvGqqmk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_c5ba3013-8030-4a42-864e-70d85ab31f89",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166911",
      "source": "custom",
      "poi_name": "Royer Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "190 Park Dr, Roseville, CA 95678, USA",
      "poi_short_description": "Home to the Children's Art Center, the space also has picnic & play areas as well as horseshoe pits.",
      "poi_long_description": "People say this park offers a variety of amenities, including playgrounds, basketball courts, tennis courts, and walking paths. They highlight the park's clean and well-maintained facilities, as well as the abundance of shade and green spaces. They also like the peaceful and relaxing atmosphere, and the family-friendly environment.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166911/019d08b1-862c-753e-b1f6-8240cac67fe3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08b1-862c-753e-b1f6-8240cac67fe3",
        "storage_key": "property/6767906449166911/019d08b1-862c-753e-b1f6-8240cac67fe3.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.roseville.ca.us/government/departments/parks/parks_places/royer_park",
      "poi_directions_map_url": "https://maps.google.com/?cid=438860327728013116&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "royer-park",
      "poi_latitude": "38.7459127",
      "poi_longitude": "-121.2828289",
      "poi_miles_from_property": "5.3",
      "poi_walking_minutes": "1 hour 58 mins",
      "poi_biking_minutes": "30 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 916-772-7529",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166911/019d08b1-1e6a-759b-a5d4-1e4fbed843f5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08b1-1e6a-759b-a5d4-1e4fbed843f5",
        "storage_key": "property/6767906449166911/019d08b1-1e6a-759b-a5d4-1e4fbed843f5.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ090SHT8gm4ARPF89lCQlFwY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_1f60e7d8-dcad-42b4-af6c-ea25749faa95",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166911",
      "source": "custom",
      "poi_name": "Adventist Health Corporate Office",
      "poi_type": "Major Employers & Offices",
      "poi_address": "One Adventist Health Way, Roseville, CA 95661, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166911/019d08b0-f852-73dc-991b-c8c0141fef29.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08b0-f852-73dc-991b-c8c0141fef29",
        "storage_key": "property/6767906449166911/019d08b0-f852-73dc-991b-c8c0141fef29.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://adventisthealth.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7527772297905000202&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "adventist-health-corporate-office",
      "poi_latitude": "38.7569855",
      "poi_longitude": "-121.2519719",
      "poi_miles_from_property": "4.5",
      "poi_walking_minutes": "1 hour 42 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 916-406-0000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166911/019d08b1-0e14-7534-bfa0-5ba263f04505.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08b1-0e14-7534-bfa0-5ba263f04505",
        "storage_key": "property/6767906449166911/019d08b1-0e14-7534-bfa0-5ba263f04505.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJncKXiO8fm4ARCk-nZgUFeGg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_d205e54d-31f5-49d5-a3cc-c0224a7172f2",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166911",
      "source": "custom",
      "poi_name": "Hewlett Packard Enterprise",
      "poi_type": "Major Employers & Offices",
      "poi_address": "8000 Foothills Blvd, Roseville, CA 95747, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166911/019d08b0-f8c2-76bd-9ff4-1512faa5beb1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08b0-f8c2-76bd-9ff4-1512faa5beb1",
        "storage_key": "property/6767906449166911/019d08b0-f8c2-76bd-9ff4-1512faa5beb1.webp",
        "width": 1080,
        "height": 608
      },
      "poi_business_url": "https://www.hpe.com/us/en/home.html",
      "poi_directions_map_url": "https://maps.google.com/?cid=11168594821131035904&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "hewlett-packard-enterprise",
      "poi_latitude": "38.7849688",
      "poi_longitude": "-121.3163292",
      "poi_miles_from_property": "3.4",
      "poi_walking_minutes": "1 hour 16 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 888-342-2156",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166911/019d08b1-0e14-7534-bfa0-5ba263f04505.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08b1-0e14-7534-bfa0-5ba263f04505",
        "storage_key": "property/6767906449166911/019d08b1-0e14-7534-bfa0-5ba263f04505.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJURi8130hm4ARAGXI6dDR_po",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_055bdf04-0198-4ade-85d0-5693901f36af",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166911",
      "source": "custom",
      "poi_name": "Alta California Regional Center - Roseville",
      "poi_type": "Major Employers & Offices",
      "poi_address": "516 Gibson Dr #150, Roseville, CA 95678, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "http://www.altaregional.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16993152713332891207&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "alta-california-regional-center---roseville",
      "poi_latitude": "38.779814",
      "poi_longitude": "-121.2730978",
      "poi_miles_from_property": "3.3",
      "poi_walking_minutes": "1 hour 14 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 916-437-6900",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166911/019d08b1-0e14-7534-bfa0-5ba263f04505.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08b1-0e14-7534-bfa0-5ba263f04505",
        "storage_key": "property/6767906449166911/019d08b1-0e14-7534-bfa0-5ba263f04505.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ47RgO_Yfm4ARRx4s9FvO0-s",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_f2ce149a-c486-43f8-aa96-ed7e33b0b230",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166911",
      "source": "custom",
      "poi_name": "KRATOS",
      "poi_type": "Major Employers & Offices",
      "poi_address": "2901 Douglas Blvd STE 105, Roseville, CA 95661, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "http://www.kratosusd.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=313016841676869165&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "kratos",
      "poi_latitude": "38.74523629999999",
      "poi_longitude": "-121.2387311",
      "poi_miles_from_property": "5.7",
      "poi_walking_minutes": "2 hours 8 mins",
      "poi_biking_minutes": "34 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 916-991-1990",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166911/019d08b1-0e14-7534-bfa0-5ba263f04505.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08b1-0e14-7534-bfa0-5ba263f04505",
        "storage_key": "property/6767906449166911/019d08b1-0e14-7534-bfa0-5ba263f04505.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJQ8lKct0fm4ARLU7duCgPWAQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_c1c10a90-5014-49f9-913b-ed22714c4899",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166911",
      "source": "custom",
      "poi_name": "WSI Corporate Office",
      "poi_type": "Major Employers & Offices",
      "poi_address": "3750 Atherton Rd, Rocklin, CA 95765, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166911/019d08b1-886b-72af-a4dd-798f4aa4f2c2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08b1-886b-72af-a4dd-798f4aa4f2c2",
        "storage_key": "property/6767906449166911/019d08b1-886b-72af-a4dd-798f4aa4f2c2.webp",
        "width": 574,
        "height": 574
      },
      "poi_business_url": "http://www.williams-sonomainc.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14374488400562628873&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "wsi-corporate-office",
      "poi_latitude": "38.8164424",
      "poi_longitude": "-121.2953052",
      "poi_miles_from_property": "1.5",
      "poi_walking_minutes": "33 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 415-421-7900",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166911/019d08b1-0e14-7534-bfa0-5ba263f04505.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08b1-0e14-7534-bfa0-5ba263f04505",
        "storage_key": "property/6767906449166911/019d08b1-0e14-7534-bfa0-5ba263f04505.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJDfctaUcim4ARCSmCfwpxfMc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    }
  ],
  "office_hours": [
    {
      "id": "ec_6d78f4a981ae50392e1cce1b",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166911",
      "day": "MON",
      "open_time": "10:00",
      "close_time": "17:30"
    },
    {
      "id": "ec_ca14204550c0b39c915b9ecb",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166911",
      "day": "TUE",
      "open_time": "09:00",
      "close_time": "17:30"
    },
    {
      "id": "ec_c70e1787f8b8652e448c6106",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166911",
      "day": "WED",
      "open_time": "09:00",
      "close_time": "17:30"
    },
    {
      "id": "ec_b854fb0ba43e9d2aad92fe9b",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166911",
      "day": "THU",
      "open_time": "09:00",
      "close_time": "17:30"
    },
    {
      "id": "ec_cbe849b946b45f437a2b00b0",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166911",
      "day": "FRI",
      "open_time": "09:00",
      "close_time": "17:30"
    },
    {
      "id": "ec_446519252e584d211371a5eb",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166911",
      "day": "SAT",
      "open_time": "10:00",
      "close_time": "17:30"
    }
  ],
  "reviews": [
    {
      "id": "custom_0bd1d223-ab15-4eb7-bfe1-a77bde448b75",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166911",
      "rating": "5.0",
      "name": "Betty Jepsen",
      "text": "Nice place to live. Well cared for by the management.  Have made major improvements since I’ve lived here. Periodically show’s resident how important they are and does special things as breakfast on the go, bbq on a Saturday afternoon etc.",
      "date": "2024-06-10",
      "title": ""
    }
  ],
  "virtual_tours": [
    {
      "id": "custom_feed6373-5892-4f5e-bc3e-bc8c24a8ebeb",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166911",
      "source": "custom",
      "url_health_error": "false",
      "virtual_tour_description": "false",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166911/019d447f-f3c6-72ff-aeda-3037ffb92f72.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019d447f-f3c6-72ff-aeda-3037ffb92f72",
        "storage_key": "property/6767906449166911/019d447f-f3c6-72ff-aeda-3037ffb92f72.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "Sunset Summit Apartments - 2 Bedroom 1 Bath 974 Sq. Ft. Model",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=yyPUDdBTMdK"
    },
    {
      "id": "custom_9ac67949-082c-4e1e-b400-ff4914bee9b8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166911",
      "source": "custom",
      "url_health_error": "false",
      "virtual_tour_description": "false",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166911/019d4480-08ee-7387-9c7a-548a47109fe3.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019d4480-08ee-7387-9c7a-548a47109fe3",
        "storage_key": "property/6767906449166911/019d4480-08ee-7387-9c7a-548a47109fe3.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "Sunset Summit Apartments - 2 Bedroom 1 Bath 841 Sq. Ft.",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=yKn99g6eTpd"
    },
    {
      "id": "custom_655a4308-62a7-4733-abda-295f83bd29ef",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166911",
      "source": "custom",
      "url_health_error": "false",
      "virtual_tour_description": "false",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166911/019d4480-3672-72a0-9abe-ee878cf374ea.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019d4480-3672-72a0-9abe-ee878cf374ea",
        "storage_key": "property/6767906449166911/019d4480-3672-72a0-9abe-ee878cf374ea.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "Sunset Summit Apartments - Pool",
      "virtual_tour_type": "Community",
      "virtual_tour_url": "https://my.matterport.com/show/?m=5XZtNb19rEM"
    },
    {
      "id": "custom_2ae11797-51c5-4e17-b900-2f1af8e38314",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166911",
      "source": "custom",
      "url_health_error": "false",
      "virtual_tour_description": "false",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166911/019d4480-5273-758b-a286-c0d87749e452.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019d4480-5273-758b-a286-c0d87749e452",
        "storage_key": "property/6767906449166911/019d4480-5273-758b-a286-c0d87749e452.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "Sunset Summit Apartments - Fitness Center",
      "virtual_tour_type": "Community",
      "virtual_tour_url": "https://my.matterport.com/show/?m=oTLES3qYj23"
    },
    {
      "id": "custom_fe06f07f-2cf4-454e-8a6a-6999f59c03ca",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166911",
      "source": "custom",
      "url_health_error": "false",
      "virtual_tour_description": "false",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166911/019d4480-6c5f-719c-8392-01ffdae3c88a.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019d4480-6c5f-719c-8392-01ffdae3c88a",
        "storage_key": "property/6767906449166911/019d4480-6c5f-719c-8392-01ffdae3c88a.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "Sunset Summit Apartments - Indoor Spa",
      "virtual_tour_type": "Community",
      "virtual_tour_url": "https://my.matterport.com/show/?m=3vo7iaj9EyT"
    }
  ],
  "faqs": [],
  "lead_collectors": [
    {
      "lead_collector_id": "019db1c0-aea9-726e-8dec-90544c4de2cb",
      "lead_source": "LANDING_PAGE",
      "name": "Sunset Summit Landing Page",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166911"
    }
  ],
  "hyperlocal_queries": [
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166911",
      "source": "generator",
      "page_item_url": "apartments-with-washer-dryer-rocklin-ca",
      "search_query": "apartments with washer dryer in Rocklin CA",
      "category": "Amenity",
      "h1_title": "Apartments with Washer Dryer in Rocklin, CA",
      "h2_subtitle": "Discover the comfort of our apartments offering a washer dryer in Rocklin, CA. Enjoy the convenience and luxury of Sunset Summit living.",
      "page_copy": "Discover the perfect blend of convenience and comfort at Sunset Summit, where our Rocklin, CA apartments feature in-unit washer and dryer facilities for an enhanced living experience. Located in the heart of Rocklin, enjoy easy access to local amenities while benefiting from modern conveniences right in your home. \n\nAt Sunset Summit, not only will you relish having a washer and dryer in your apartment, but you'll also take advantage of our vibrant community features. Imagine enjoying a swim in our indoor spa, working out in the 24-hour fitness center, or reserving our clubhouse for events. Our prime location in Placer County puts you near shopping, dining, and entertainment, making Sunset Summit the ideal choice for those seeking quality apartment living in Rocklin.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments with Washer Dryer in Rocklin, CA",
      "seo_description": "Explore Sunset Summit's Rocklin CA apartments equipped with washer dryer, fitness center, playground, and more. Experience luxury living in Placer County.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166911",
      "source": "generator",
      "page_item_url": "luxury-apartments-swimming-pool-placer-county",
      "search_query": "luxury apartments with swimming pool Placer County",
      "category": "Amenity",
      "h1_title": "Luxury Apartments with Pool in Placer County",
      "h2_subtitle": "Experience luxury living in Placer County with our exquisite apartments featuring a swimming pool. Discover home comfort at Sunset Summit.",
      "page_copy": "Nestled in the scenic landscapes of Placer County, Sunset Summit offers luxury apartments that redefine living standards with their exceptional amenities, including an inviting swimming pool. Whether you’re unwinding after a long day or hosting friends, our apartment community provides a sophisticated backdrop for all occasions.\n\nIn addition to our metropolitan swimming pool, residents can enjoy a plethora of amenities that enhance daily life, such as a 24-hour fitness center, an indoor spa, and versatile clubhouse rentals. Situated in the vibrant city of Rocklin, CA, these luxury apartments offer a serene escape with easy access to urban conveniences and local attractions. Come explore why Sunset Summit is the perfect place to call home in Placer County.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Luxury Apartments with Pool, Placer County",
      "seo_description": "Discover luxury apartments in Placer County with a pool, fitness center, and more at Sunset Summit. Elevate your lifestyle in Rocklin, CA.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166911",
      "source": "generator",
      "page_item_url": "garage-parking-apartments-rocklin-95765",
      "search_query": "garage parking apartments Rocklin 95765",
      "category": "Amenity",
      "h1_title": "Garage Parking Apartments in Rocklin 95765",
      "h2_subtitle": "Enjoy the convenience of garage parking at Sunset Summit in Rocklin, CA, 95765. Explore our exceptional apartment features and community amenities.",
      "page_copy": "Located in the desirable zip code of 95765, Sunset Summit in Rocklin, CA offers the ultimate convenience with garage parking options for its residents. Our beautifully designed apartments ensure that you have a premium living experience, with the added benefit of secure parking to keep your vehicle safe.\n\nAt Sunset Summit, beyond just garage parking, explore our range of fantastic amenities like the 24-hour fitness center, indoor spa, and vibrant community clubhouse rentals. Perfectly positioned in the heart of Rocklin, Sunset Summit provides access to local attractions and conveniences, making it the ideal choice for those looking to enhance their living standards with thoughtful amenities.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Garage Parking Apartments in Rocklin 95765",
      "seo_description": "Discover garage parking apartments in Rocklin, CA, 95765 at Sunset Summit. Enjoy premium amenities like a fitness center, spa, and more.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166911",
      "source": "generator",
      "page_item_url": "smoke-free-apartments-near-sunset-boulevard",
      "search_query": "smoke free apartments near Sunset Boulevard",
      "category": "Amenity",
      "h1_title": "Smoke-Free Apartments Near Sunset Boulevard",
      "h2_subtitle": "Embrace a healthier lifestyle with smoke-free living near Sunset Boulevard. Discover the benefits of choosing Sunset Summit apartments.",
      "page_copy": "Sunset Summit offers smoke-free apartments conveniently located near Sunset Boulevard in Rocklin, CA. Designed with your well-being in mind, our community promotes a healthier lifestyle free from smoke, ensuring a clean and comfortable environment for all residents.\n\nBeyond our smoke-free policy, Sunset Summit provides a host of amenities that cater to modern living. Residents can enjoy a 24-hour fitness center, a peaceful indoor spa, and options for clubhouse rentals, all set within a vibrant community. Positioned near Sunset Boulevard, our apartments grant easy access to local shops, dining, and entertainment, making it the perfect home base for a balanced lifestyle.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Smoke-Free Apartments Near Sunset Boulevard",
      "seo_description": "Find smoke-free living near Sunset Boulevard at Sunset Summit in Rocklin, CA. Enjoy amenities like a fitness center and spa in a health-conscious environment.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166911",
      "source": "generator",
      "page_item_url": "fitness-center-apartments-rocklin-ca",
      "search_query": "fitness center apartments Rocklin CA",
      "category": "Amenity",
      "h1_title": "Fitness Center Apartments in Rocklin, CA",
      "h2_subtitle": "Stay active at Sunset Summit, located in Rocklin, CA. Our apartments feature a state-of-the-art fitness center open 24 hours.",
      "page_copy": "Sunset Summit in Rocklin, CA is proud to offer exceptional apartments with access to a 24-hour fitness center, perfect for maintaining an active lifestyle. Whether you're starting your day with a workout or unwinding in the evening, our fully equipped fitness facility is designed to accommodate diverse exercise routines.\n\nLiving at Sunset Summit goes beyond just access to a fitness center. Our residents also enjoy amenities such as indoor spa facilities, a lively playground, and opportunities for clubhouse rentals. Nestled in the vibrant community of Rocklin, CA, Sunset Summit provides the ideal setting for balancing fitness goals with home comfort and local convenience.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Fitness Center Apartments in Rocklin, CA",
      "seo_description": "Discover apartments with a 24-hour fitness center at Sunset Summit in Rocklin, CA. Enjoy modern living and essential amenities for an active lifestyle.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166911",
      "source": "generator",
      "page_item_url": "one-bedroom-apartments-rocklin-ca",
      "search_query": "one bedroom apartments in Rocklin CA",
      "category": "Floorplan",
      "h1_title": "One Bedroom Apartments in Rocklin, CA",
      "h2_subtitle": "Discover the perfect one-bedroom apartment at Sunset Summit in Rocklin, CA. Enjoy modern amenities in a vibrant community.",
      "page_copy": "Sunset Summit in Rocklin, CA offers beautifully designed one-bedroom apartments that cater to those seeking comfort and functionality. Our residences provide a spacious living environment with an array of modern amenities to enhance your lifestyle.\n\nBeyond the comfort of your one-bedroom apartment, Sunset Summit boasts features like a 24-hour fitness center, relaxing indoor spa, and available clubhouse rentals. Conveniently located in Rocklin, CA, our community ensures easy access to Sunset Boulevard's dining, shopping, and entertainment options, making it an ideal place to call home.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "One Bedroom Apartments in Rocklin, CA",
      "seo_description": "Explore one-bedroom apartments at Sunset Summit in Rocklin, CA. Enjoy a vibrant community with amenities like a fitness center and spa.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166911",
      "source": "generator",
      "page_item_url": "two-bedroom-apartments-near-95765",
      "search_query": "two bedroom apartments near 95765",
      "category": "Floorplan",
      "h1_title": "Two Bedroom Apartments Near 95765",
      "h2_subtitle": "Explore spacious two-bedroom apartments at Sunset Summit, ideally located near the 95765 area. Enjoy modern amenities and a community atmosphere.",
      "page_copy": "Discover comfortable two-bedroom apartments at Sunset Summit, conveniently located near the 95765 area in Rocklin, CA. Designed with both style and functionality in mind, these apartments offer ample space and modern features that support a fulfilling lifestyle.\n\nAt Sunset Summit, residents not only enjoy beautifully appointed two-bedroom layouts but also a host of amenities including a 24-hour fitness center, relaxing indoor spa, and options for clubhouse rentals. Nestled in the vibrant Rocklin community, Sunset Summit provides easy access to dining, shopping, and entertainment venues, making it an ideal residence for those looking to thrive in the 95765 vicinity.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Two Bedroom Apartments Near 95765",
      "seo_description": "Find spacious two-bedroom apartments at Sunset Summit near 95765 in Rocklin, CA. Enjoy ample amenities and vibrant community living.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166911",
      "source": "generator",
      "page_item_url": "three-bedroom-apartments-placer-county",
      "search_query": "three bedroom apartments Placer County",
      "category": "Floorplan",
      "h1_title": "Three Bedroom Apartments in Placer County",
      "h2_subtitle": "Spacious three-bedroom apartments at Sunset Summit cater to those seeking comfortable living in Placer County. Experience our vibrant community today.",
      "page_copy": "Sunset Summit proudly offers expansive three-bedroom apartments in Placer County, perfect for families or those needing extra space. These apartments are designed to balance comfort and modern living, ensuring you have all the room you need while enjoying a stylish home.\n\nLocated in the heart of Rocklin, CA, Sunset Summit combines spacious living with top-tier amenities such as a 24-hour fitness center, an indoor spa, and options for clubhouse rentals. Whether you're connecting with the community at our playground or exploring the local attractions, Sunset Summit in Placer County offers the perfect backdrop for a fulfilling lifestyle.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Three Bedroom Apartments in Placer County",
      "seo_description": "Explore three-bedroom apartments at Sunset Summit in Placer County. Enjoy spacious living with top amenities like a fitness center and indoor spa.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166911",
      "source": "generator",
      "page_item_url": "apartments-near-sierra-college-rocklin",
      "search_query": "apartments near Sierra College Rocklin",
      "category": "School",
      "h1_title": "Apartments Near Sierra College Rocklin",
      "h2_subtitle": "Conveniently located near Sierra College in Rocklin, Sunset Summit offers contemporary living and excellent amenities for students and professionals alike.",
      "page_copy": "Sunset Summit provides an ideal living solution for students and professionals looking for apartments near Sierra College in Rocklin. Our community offers modern apartment options, perfectly combining style and convenience just minutes from the college campus.\n\nResidents at Sunset Summit benefit from a plethora of on-site amenities, including a 24-hour fitness center, an inviting indoor spa, and rentable clubhouse facilities. Whether unwinding after a long day or preparing for a study session, our complex's peaceful and well-equipped environment caters to a balanced lifestyle close to Sierra College and Rocklin's vibrant attractions.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Sierra College Rocklin",
      "seo_description": "Find modern apartments near Sierra College at Sunset Summit, Rocklin. Enjoy proximity to campus and amenities like a fitness center and spa.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166911",
      "source": "generator",
      "page_item_url": "apartments-close-to-jessup-university-placer-county",
      "search_query": "apartments close to Jessup University Placer County",
      "category": "School",
      "h1_title": "Apartments Close to Jessup University",
      "h2_subtitle": "Sunset Summit in Placer County offers comfortable apartments close to Jessup University, providing students and staff with a welcoming place to call home.",
      "page_copy": "Located in Rocklin, CA, Sunset Summit is the perfect community for those seeking apartments close to Jessup University in Placer County. Our apartments offer a blend of convenience and modern living, making them ideal for students and faculty members who desire a short commute to campus.\n\nAt Sunset Summit, you can enjoy a variety of community amenities designed to enhance your living experience, including a 24-hour fitness center, indoor spa, and rentable clubhouse facilities. Situated near major thoroughfares and local attractions, these apartments offer not just proximity to Jessup University but also access to the vibrant life in Placer County, ensuring a fulfilling residency.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Close to Jessup University",
      "seo_description": "Discover stylish apartments at Sunset Summit near Jessup University Placer County. Enjoy great amenities and a prime location near campus.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166911",
      "source": "generator",
      "page_item_url": "apartments-near-sutter-roseville-medical-center-rocklin",
      "search_query": "apartments near Sutter Roseville Medical Center Rocklin",
      "category": "Hospital",
      "h1_title": "Apartments Near Sutter Roseville Medical Center",
      "h2_subtitle": "Sunset Summit offers convenient apartment living near Sutter Roseville Medical Center in Rocklin, perfect for healthcare professionals seeking nearby accommodations.",
      "page_copy": "At Sunset Summit, discover ideal apartments near Sutter Roseville Medical Center in Rocklin. Our community provides a comfortable and hassle-free living environment for healthcare professionals and anyone seeking proximity to this major medical facility.\n\nWith amenities such as a 24-hour fitness center, indoor spa, and accessible clubhouse rentals, Sunset Summit blends convenience with leisure, enhancing your residential experience. Located in Rocklin, our community ensures easy access to both work at the medical center and relaxation at home, all set within Placer County's dynamic environment.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Sutter Roseville Medical Center",
      "seo_description": "Find comfortable apartments at Sunset Summit near Sutter Roseville Medical Center in Rocklin. Enjoy great amenities and convenient location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166911",
      "source": "generator",
      "page_item_url": "apartments-close-to-kaiser-permanente-roseville-medical-center",
      "search_query": "apartments close to Kaiser Permanente Roseville Medical Center Building C 95765",
      "category": "Hospital",
      "h1_title": "Apartments Close to Kaiser Permanente",
      "h2_subtitle": "Sunset Summit offers convenient living options close to Kaiser Permanente Roseville Medical Center Building C, located in the heart of Rocklin.",
      "page_copy": "Sunset Summit presents an excellent opportunity for those searching for apartments close to Kaiser Permanente Roseville Medical Center Building C in the 95765 area. Our community provides a seamless blend of comfort and convenience, making it an ideal choice for medical professionals and anyone who desires a short commute.\n\nEnjoy the benefits of living at Sunset Summit, where modern apartments are complemented by amenities like a 24-hour fitness center, indoor spa, and rentable clubhouse facilities. Positioned in Rocklin, residents appreciate not only proximity to Kaiser Permanente but also easy access to Placer County's vibrant lifestyle offerings and natural landscapes, ensuring a well-rounded living experience.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Close to Kaiser Permanente Roseville",
      "seo_description": "Explore Sunset Summit for stylish apartments near Kaiser Permanente Roseville Medical Center Building C, 95765. Enjoy proximity and great amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166911",
      "source": "generator",
      "page_item_url": "apartments-near-maidu-regional-park-rocklin",
      "search_query": "apartments near Maidu Regional Park Rocklin",
      "category": "Park",
      "h1_title": "Apartments Near Maidu Regional Park",
      "h2_subtitle": "Discover Sunset Summit, offering apartment living near Maidu Regional Park in Rocklin, perfect for nature lovers and active residents.",
      "page_copy": "Situated in Rocklin, Sunset Summit provides apartments perfectly placed near the scenic Maidu Regional Park. Known for its expansive green spaces and variety of recreational activities, Maidu Regional Park is a haven for outdoor enthusiasts.\n\nResidents of Sunset Summit benefit from this proximity, with easy access to miles of trails, sports courts, and picnic areas. After a day at the park, unwind at home with amenities like our indoor spa, fitness center open around the clock, and a welcoming community atmosphere. Experience the blend of nature and modern living at Sunset Summit, ideal for active lifestyles in Placer County.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Maidu Regional Park Rocklin",
      "seo_description": "Find your home at Sunset Summit, where apartments near Maidu Regional Park in Rocklin offer nature access and modern amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166911",
      "source": "generator",
      "page_item_url": "apartments-close-to-johnson-springview-park-rocklin",
      "search_query": "apartments close to Johnson-Springview Park CA",
      "category": "Park",
      "h1_title": "Apartments Close to Johnson-Springview Park",
      "h2_subtitle": "Live at Sunset Summit, just moments from Johnson-Springview Park in Rocklin, CA. Ideal for those seeking an active yet serene lifestyle.",
      "page_copy": "Sunset Summit offers an inviting community for those seeking apartments close to Johnson-Springview Park in Rocklin, CA. Renowned for its open spaces, skate park, and sports facilities, Johnson-Springview Park offers leisure and recreation options just a short distance away.\n\nExperience the convenience of living near this vibrant park while enjoying the modern comforts of Sunset Summit. With amenities such as a 24-hour fitness center and indoor spa, our community provides the perfect balance of activity and relaxation. Discover the ideal setting for embracing an active lifestyle in Placer County while appreciating the tranquility of your new home at Sunset Summit.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Close to Johnson-Springview Park, CA",
      "seo_description": "Discover Sunset Summit apartments near Johnson-Springview Park, Rocklin, CA. Enjoy recreational facilities and modern amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166911",
      "source": "generator",
      "page_item_url": "apartments-near-harry-crabb-park-placer-county",
      "search_query": "apartments near Harry Crabb Park Placer County",
      "category": "Park",
      "h1_title": "Apartments Near Harry Crabb Park",
      "h2_subtitle": "Sunset Summit offers apartments conveniently located near Harry Crabb Park in Placer County, perfect for those who enjoy parkside living.",
      "page_copy": "Located in the heart of Rocklin, Sunset Summit provides premier apartments near Harry Crabb Park, Placer County. Known for its extensive sports fields and open spaces, this park is a favorite destination for both families and sports enthusiasts.\n\nAt Sunset Summit, you'll enjoy the benefits of park proximity alongside a host of modern amenities, including an indoor spa and a clubhouse ready for social gatherings. Our robust fitness center is open 24 hours, catering to all lifestyles. Discover the perfect combination of leisure and comfort at Sunset Summit, where community and nature seamlessly coexist in Placer County.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Harry Crabb Park Placer County",
      "seo_description": "Find Sunset Summit apartments near Harry Crabb Park, Rocklin. Enjoy nearby recreational options and excellent amenities in Placer County.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166911",
      "source": "generator",
      "page_item_url": "apartments-close-to-mahany-park-95765",
      "search_query": "apartments close to Mahany Park 95765",
      "category": "Park",
      "h1_title": "Apartments Close to Mahany Park",
      "h2_subtitle": "Explore Sunset Summit, offering exceptional apartment living close to Mahany Park in the 95765 area. Perfect for active lifestyles and community fun.",
      "page_copy": "Sunset Summit features beautifully designed apartments conveniently located close to Mahany Park in the 95765 area. Known for its extensive recreational facilities, including a sports complex and verdant spaces, Mahany Park is an ideal spot for families and active individuals.\n\nResidents at Sunset Summit benefit from easy access to this vibrant park while enjoying our exclusive onsite amenities like a 24-hour fitness center and an inviting indoor spa. Whether you prefer a quiet evening at home or outdoor adventures, Sunset Summit combines convenience and comfort, making it an ideal home for those seeking a balanced lifestyle in the Rocklin community.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Close to Mahany Park 95765",
      "seo_description": "Discover Sunset Summit in Rocklin, offering apartments near Mahany Park 95765. Enjoy park access and premium amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166911",
      "source": "generator",
      "page_item_url": "apartments-near-royer-park-rocklin",
      "search_query": "apartments near Royer Park Rocklin",
      "category": "Park",
      "h1_title": "Apartments Near Royer Park, Rocklin",
      "h2_subtitle": "Live near Royer Park in Rocklin at Sunset Summit, where serene park views and modern living combine for an unmatched experience.",
      "page_copy": "Sunset Summit is proud to offer charming apartments near Royer Park in Rocklin. Known for its beautiful green landscapes, playground, and community events, Royer Park provides a perfect setting for relaxation and fun.\n\nAt Sunset Summit, residents enjoy modern amenities such as clubhouse rentals and a playground right on their doorstep. With its proximity to Royer Park, communities like ours offer an exceptional living experience for those who appreciate a blend of nature and convenience. Come explore the enriching lifestyle at Sunset Summit, where each day offers new opportunities to enjoy Rocklin's vibrant community.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Royer Park Rocklin",
      "seo_description": "Explore Sunset Summit in Rocklin, with apartments close to Royer Park. Enjoy modern amenities and serene park proximity.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    }
  ],
  "custom_fields": [
    {
      "ID": "custom_qb_id",
      "type": "STRING",
      "value": "5967"
    },
    {
      "ID": "custom_repli_id",
      "type": "STRING",
      "value": "18372416270"
    },
    {
      "ID": "custom_google_gtm_id",
      "type": "STRING",
      "value": "GTM-TX9J7RHT"
    },
    {
      "ID": "custom_hubspot_company_id",
      "type": "STRING",
      "value": "54751435426"
    },
    {
      "ID": "custom_company_license_number",
      "type": "STRING",
      "value": "#01090130"
    },
    {
      "ID": "custom_ppc_tracking_phone_number",
      "type": "STRING",
      "value": "844-549-6800 "
    }
  ],
  "custom_qb_id": "5967",
  "custom_repli_id": "18372416270",
  "custom_google_gtm_id": "GTM-TX9J7RHT",
  "custom_hubspot_company_id": "54751435426",
  "custom_company_license_number": "#01090130",
  "custom_ppc_tracking_phone_number": "844-549-6800 "
};

export const generatedAt = '2026-09-23T19:54:41.212Z';
